import { icon, marker, polygon, GeoJSON, ExtraMarkers, Marker, geoJSON, LayerGroup, multiOptionsPolyline, latLng, tileLayer, featureGroup, Polygon } from 'leaflet';
import 'leaflet-rotatedmarker';
import moment from 'moment';
import { bbox, lineString, area, length } from '@turf/turf';
import { parse, convert } from 'terraformer-wkt-parser';
import { isArray, isFunction, bind, sum, values, groupBy, map as map$1 } from 'lodash';
import { Subject, throwError, of, ReplaySubject } from 'rxjs';
import { defaultModules, Stack, alert } from '@pnotify/core';
import 'leaflet-extra-markers';
import RBush from 'rbush';
import { saveAs } from 'file-saver';
import * as leafletImage from 'leaflet-image';
import { __awaiter } from 'tslib';
import CustomStore from 'devextreme/data/custom_store';
import { HttpParams, HttpClient, HttpHeaders, HTTP_INTERCEPTORS, HttpErrorResponse } from '@angular/common/http';
import { tap, map, catchError, mergeMap, first } from 'rxjs/operators';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import { arrayToTree } from 'performant-array-to-tree';
import { ɵɵinject, ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, APP_INITIALIZER, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, Optional, SkipSelf, InjectionToken, EventEmitter, Inject, ɵɵdefineComponent, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, Component, ɵɵelementContainerStart, ɵɵelement, ɵɵelementContainerEnd, ɵɵnextContext, ɵɵadvance, ɵɵtextInterpolate, ɵɵproperty, ɵɵsanitizeHtml, ɵɵtemplate, Input, Injector, ɵɵnamespaceSVG, ɵɵattribute, ɵɵgetCurrentView, ɵɵlistener, ɵɵrestoreView, ɵɵviewQuery, ɵɵqueryRefresh, ɵɵloadQuery, ɵɵpureFunction0, ɵɵpureFunction1, Output, ViewChild, ɵɵclassMapInterpolate1, ɵɵdirectiveInject, Renderer2, ɵɵsanitizeUrl, ɵɵpureFunction2, ɵɵprojectionDef, ɵɵprojection, ɵɵclassMapInterpolate3, ɵɵdefineDirective, Directive, ɵɵtextInterpolate1, ɵɵtextInterpolate2, ɵɵNgOnChangesFeature } from '@angular/core';
import { CommonModule, NgForOf, NgStyle, NgIf } from '@angular/common';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import dxNotify from 'devextreme/ui/notify';
import { DxScrollViewComponent, DxScrollViewModule, DxButtonComponent, DxPopupComponent, DxPopupModule, DxButtonModule, DxFileUploaderModule, DxDataGridComponent, DxLoadPanelComponent, DxDataGridModule, DxLoadPanelModule, DxSelectBoxComponent, DxSelectBoxModule, DxTextBoxComponent, DxTextBoxModule, DxFormComponent, DxFormModule, DxLoadIndicatorModule, DxTreeListComponent, DxDropDownBoxComponent, DxDropDownBoxModule, DxTreeViewComponent, DxTreeViewModule } from 'devextreme-angular';
import { createCustomElement } from '@angular/elements';
import 'leaflet-draw';
import { DxiToolbarItemComponent, DxoEditingComponent, DxiColumnComponent, DxiValidationRuleComponent, DxoExportComponent, DxoPagingComponent, DxoFilterRowComponent, DxiButtonComponent, DxiItemComponent, DxoLookupComponent, DxoPopupComponent, DxoFormComponent, DxoColumnChooserComponent, DxoGroupPanelComponent, DxoSortingComponent, DxoPagerComponent, DxoSearchPanelComponent, DxoHeaderFilterComponent, DxoSelectionComponent, DxoDropDownOptionsComponent } from 'devextreme-angular/ui/nested';
import { DxTemplateDirective } from 'devextreme-angular/core';
import { LeafletDirective, LeafletLayersControlDirective, LeafletLayerDirective, LeafletModule } from '@asymmetrik/ngx-leaflet';
import { LeafletDrawDirective, LeafletDrawModule } from '@asymmetrik/ngx-leaflet-draw';
import { Workbook } from 'exceljs';
import { confirm } from 'devextreme/ui/dialog';
import smartcrop from 'smartcrop/smartcrop';

class BaseModel {
    constructor(data) {
        Object.assign(this, data);
    }
}

class Permission extends BaseModel {
}

class Role extends BaseModel {
    constructor(data) {
        super(data);
        if (this.permissions) {
            this.permissions = this.permissions.map(p => new Permission(p));
        }
    }
}

class Domain extends BaseModel {
}

class UserDomain extends BaseModel {
}
class UserDomainDetails extends Domain {
}

class User extends BaseModel {
    constructor(data) {
        super(data);
        this.domains = [];
        if (data.impersonated_by) {
            this.impersonated_by = new User(data.impersonated_by);
        }
        this.role = new Role(this.role);
        if (this.permissions) {
            this.permissions = this.permissions.map(p => new Permission(p));
        }
        if (data.hasOwnProperty('domains')) {
            this.domains = data.domains.map(d => new UserDomainDetails(d));
        }
    }
    photoUrl() {
        if (this.photo === null) {
            return 'assets/images/profile.png';
        }
        return this.photo;
    }
    can(...permissions) {
        if (!this.permissions || this.permissions.length === 0) {
            return false;
        }
        for (const checkPermission of permissions) {
            const permissionFound = this.permissions.find(x => x.name === checkPermission);
            if (!permissionFound) {
                return false;
            }
        }
        return true;
    }
    any(...permissions) {
        if (!this.permissions || this.permissions.length === 0) {
            return false;
        }
        for (const checkPermission of permissions) {
            const permissionFound = this.permissions.find(x => x.name === checkPermission);
            if (permissionFound) {
                return true;
            }
        }
        return false;
    }
}

var TrackerState;
(function (TrackerState) {
    TrackerState[TrackerState["Moving"] = 1] = "Moving";
    TrackerState[TrackerState["Idle"] = 2] = "Idle";
    TrackerState[TrackerState["Stopped"] = 3] = "Stopped";
    TrackerState[TrackerState["Offline"] = 4] = "Offline";
})(TrackerState || (TrackerState = {}));
class TrackerSettings {
    constructor(data) {
        Object.assign(this, data);
        if (!this.calibration) {
            this.calibration = [];
        }
    }
}
class Tracker extends BaseModel {
    constructor(data) {
        super(data);
        if (data.tractor && data.tractor.id) {
            this.tractor = new Tractor(data.tractor);
        }
        if (data.settings) {
            this.settings = new TrackerSettings(data.settings);
        }
    }
    acc() {
        return this.params.IN5 !== 0;
    }
    hasFlowMeter() {
        var _a, _b;
        return ((_a = this.params) === null || _a === void 0 ? void 0 : _a.FuelTemperature) > 0 || ((_b = this.params) === null || _b === void 0 ? void 0 : _b.EngineCoolantTemperature) > 0;
    }
    state() {
        if (this.tracker_time === null) {
            return TrackerState.Offline;
        }
        if (this.acc() && this.speed > 0) {
            return TrackerState.Moving;
        }
        else if (this.acc() && this.speed === 0) {
            return TrackerState.Idle;
        }
        else {
            return TrackerState.Stopped;
        }
    }
    stateArrowIcon() {
        switch (this.state()) {
            case TrackerState.Moving:
                return '/assets/icons/arrow_green.png';
            case TrackerState.Idle:
                return '/assets/icons/arrow_orange.png';
            case TrackerState.Stopped:
                return '/assets/icons/arrow_red.png';
        }
        return '/assets/icons/arrow_grey.png';
    }
    marker() {
        const icon$1 = icon({
            iconUrl: this.stateArrowIcon(),
            iconSize: [16, 24],
            iconAnchor: [8, 24]
        });
        return marker([this.lat, this.lng], {
            icon: icon$1,
            rotationAngle: this.angle,
            rotationOrigin: 'center center',
        });
    }
    toString() {
        return JSON.stringify(this);
    }
}

class Vehicle extends BaseModel {
}
class VehicleSettings {
    constructor(data) {
        Object.assign(this, data);
        this.tracker_state_icons = data.tracker_state_icons ? this.tracker_state_icons.map(i => new VehicleTrackerStateIcon(i)) : [];
    }
    getTrackerStateIconUrl(state, defaultIcon) {
        const icon = this.tracker_state_icons.find(i => i.state === state);
        return icon ? icon.icon : defaultIcon;
    }
    getTrackerStateIcon(state, defaultIcon) {
        const stateIcon = this.tracker_state_icons.find(i => i.state === state);
        if (stateIcon) {
            return stateIcon;
        }
        const newStateIcon = new VehicleTrackerStateIcon({
            state,
            icon: defaultIcon
        });
        this.tracker_state_icons.push(newStateIcon);
        return newStateIcon;
    }
}
class VehicleTrackerStateIcon {
    constructor(data) {
        Object.assign(this, data);
    }
}

class Tractor extends BaseModel {
    constructor(data) {
        super(data);
        this.interventionStatusWatcher = 0;
        if (data.tracker && data.tracker.id) {
            this.tracker = new Tracker(data.tracker);
        }
        if (data.settings) {
            this.settings = new VehicleSettings(data.settings);
        }
        else {
            this.settings = new VehicleSettings({});
        }
    }
    get interventionStatus() {
        return this._interventionStatus;
    }
    set interventionStatus(value) {
        this.interventionStatusSetTime = Date.now();
        if (this.interventionStatusWatcher > 0) {
            clearInterval(this.interventionStatusWatcher);
        }
        this.interventionStatusWatcher = window.setInterval(() => {
            if (this._interventionStatus.finished() && moment().diff(this.interventionStatusSetTime, 'minutes') > 1) {
                this._interventionStatus = null;
                clearInterval(this.interventionStatusWatcher);
            }
        }, 2000);
        this._interventionStatus = value;
    }
}

class TrackerAssignment extends BaseModel {
    constructor(data) {
        super(data);
        if (this.tracker) {
            this.tracker = new Tracker(this.tracker);
        }
    }
}

class BusinessUnit extends BaseModel {
    constructor(data) {
        super(data);
        if (this.manager) {
            this.manager = new User(this.manager);
        }
        if (this.operations_manager) {
            this.operations_manager = new User(this.operations_manager);
        }
    }
}

// import * as jsts from 'jsts';
class BasePolygonModel extends BaseModel {
    get geojson() {
        if (!this._geojson) {
            this._geojson = parse(this.polygon);
        }
        return this._geojson;
    }
    set geojson(value) {
        this.polygon = convert(value);
        this._bbox = null;
        value.coordinates = value.coordinates.map((c) => {
            return c.map((cc) => {
                return [parseFloat(cc[0].toPrecision(6)),
                    parseFloat(cc[1].toPrecision(6))];
            });
        });
        this._geojson = value;
    }
    get layer() {
        if (!this._layer) {
            this._layer = this.createLayer();
        }
        return this._layer;
    }
    set layer(value) {
        this._layer = value;
        this.geojson = value.toGeoJSON().geometry;
    }
    createLayer(options) {
        return polygon(GeoJSON.coordsToLatLngs(this.geojson.coordinates, 1), options);
    }
    cloneLayer(options) {
        return this.createLayer(options);
    }
    getBounds() {
        return this.layer.getBounds();
    }
    svgPath(width, height) {
        const points = [];
        for (const p of this.geojson.coordinates[0]) {
            const x = (p[0] + 180) * (width / 360);
            const latRad = p[1] * Math.PI / 180;
            const mercN = Math.log(Math.tan((Math.PI / 4) + (latRad / 2)));
            const y = (height / 2) - (width * mercN / (2 * Math.PI));
            points.push([x, y]);
        }
        const bbox$1 = bbox(lineString(points));
        return [points.map(p => p.join(',')).join(' '), [bbox$1[0], bbox$1[1], bbox$1[2] - bbox$1[0], bbox$1[3] - bbox$1[1]].join(' ')];
    }
    polygonAreaToHa() {
        return this.polygon_area / 10000;
    }
    polygonAreaToHaUnit() {
        return this.polygonAreaToHa().toFixed(2) + 'Ha';
    }
    get bbox() {
        if (!this._bbox) {
            const bbBox = bbox(this.geojson);
            this._bbox = {
                minX: bbBox[0],
                minY: bbBox[1],
                maxX: bbBox[2],
                maxY: bbBox[3],
            };
        }
        return this._bbox;
    }
}

class Crop extends BaseModel {
    constructor(data) {
        super(data);
        if (data.path) {
            this.path_str = data.path.map((e) => e.name).join(' > ');
        }
        if (data.custom_fields) {
            this.custom_fields = Object.values(data.custom_fields);
        }
    }
    toColumns(parent, root) {
        const columns = [];
        if (!this.custom_fields) {
            return columns;
        }
        this.custom_fields.forEach((sf) => {
            var _a;
            const column = Object.assign({}, sf, {
                dataField: `${root}.${sf.dataField}`,
                caption: (_a = sf.label) === null || _a === void 0 ? void 0 : _a.text,
            });
            this.setupValidationRules(parent, sf);
            columns.push(column);
        });
        return columns;
    }
    setupValidationRules(parent, sf) {
        if (!isArray(sf.validationRules)) {
            return;
        }
        sf.validationRules.forEach(rule => {
            if (rule.type === 'async' && rule.hasOwnProperty('validationCallback')) {
                if (isFunction(parent[rule.validationCallback])) {
                    rule.validationCallback = bind(parent[rule.validationCallback], parent, bind.placeholder, sf.dataField);
                }
                else {
                    rule.validationCallback = new Promise((resolve) => {
                        resolve(true);
                    });
                }
            }
        });
    }
    customFieldsPreview(values) {
        return this.custom_fields.map(f => {
            var _a;
            return { caption: (_a = f.label) === null || _a === void 0 ? void 0 : _a.text, value: values[f.dataField] || 'NA' };
        });
    }
}

class FieldCropNote {
}
class FieldCrop extends BasePolygonModel {
    constructor(data) {
        super(data);
        if (data.crop) {
            this.crop = new Crop(data.crop);
        }
    }
    static newFromLayer(fieldId, layer) {
        const crop = new FieldCrop({
            field_id: fieldId,
            name: 'Sans Nom',
            color: '#' + (0x1000000 + (Math.random()) * 0xffffff).toString(16).substr(1, 6),
        });
        crop.layer = layer;
        crop.polygon_area = area(crop.geojson);
        return crop;
    }
}

class Field extends BasePolygonModel {
    // polygon_area: number;
    constructor(data) {
        super(data);
        if (data.field_crop_name) {
            this.field_crop = new FieldCrop({
                name: data.field_crop_name,
                cadastral_area: data.field_crop_cadastral_area,
            });
        }
        if ((data === null || data === void 0 ? void 0 : data.crop_name) && (data === null || data === void 0 ? void 0 : data.crop_path)) {
            this.crop = new Crop({
                name: data.crop_name,
                path: data.crop_path
            });
        }
    }
    static newFromLayer(layer) {
        const crop = new Field({
            name: 'Sans Nom',
            color: '#' + (0x1000000 + (Math.random()) * 0xffffff).toString(16).substr(1, 6),
        });
        crop.layer = layer;
        crop.polygon_area = area(crop.geojson);
        return crop;
    }
    /*  svgPath(width: number, height: number): [string, string] {
        const points: number[][] = [];
        for (const p of this.polygon) {
          const x = (p[0] + 180) * (width / 360);
          const latRad = p[1] * Math.PI / 180;
          const mercN = Math.log(Math.tan((Math.PI / 4) + (latRad / 2)));
          const y = (height / 2) - (width * mercN / (2 * Math.PI));
          points.push([x, y]);
        }
        const bbox = turf.bbox(turf.lineString(points));
        return [points.map(p => p.join(',')).join(' '), [bbox[0], bbox[1], bbox[2] - bbox[0], bbox[3] - bbox[1]].join(' ')];
      }*/
    toSVG(width, height, strokeWidth = 1) {
        const points = [];
        for (const p of this.geojson.coordinates[0]) {
            const x = (p[0] + 180) * (width / 360);
            const latRad = p[1] * Math.PI / 180;
            const mercN = Math.log(Math.tan((Math.PI / 4) + (latRad / 2)));
            const y = (height / 2) - (width * mercN / (2 * Math.PI));
            points.push([x, y]);
        }
        const bbox$1 = bbox(lineString(points));
        const lightColor = this.color.padEnd(7, 'f') + '20';
        let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" x="0" y="0" viewBox="${bbox$1[0]} ${bbox$1[1]} ${bbox$1[2] - bbox$1[0]} ${bbox$1[3] - bbox$1[1]}">
      <polygon points="`;
        svg += points.map(p => p.join(',')).join(' ');
        svg += `" style="stroke:${this.color}; fill:${lightColor};stroke-width:${strokeWidth};" vector-effect="non-scaling-stroke"></polygon></svg>`;
        return svg;
    }
}

class TrailerOperationTypeRules {
    constructor(data) {
        Object.assign(this, data);
    }
}
class TrailerOperationTypeSettings {
    constructor(data) {
        Object.assign(this, data);
    }
}
class TrailerOperationType extends BaseModel {
    constructor(data) {
        super(data);
        if (this.rules) {
            this.rules = new TrailerOperationTypeRules(this.rules);
        }
        if (this.settings) {
            this.settings = new TrailerOperationTypeSettings(this.settings);
        }
    }
}

class Trailer extends BaseModel {
    constructor(data) {
        super(data);
        if (this.operation_type_rules) {
            this.operation_type_rules = new TrailerOperationTypeRules(this.operation_type_rules);
        }
        if (this.operation_type_settings) {
            this.operation_type_settings = new TrailerOperationTypeSettings(this.operation_type_settings);
        }
    }
    get taggable_domain_id() {
        return this.domain_id;
    }
    get taggable_id() {
        return this.id;
    }
    get taggable_name() {
        return this.name;
    }
    get taggable_properties() {
        return null;
    }
    get taggable_type() {
        return 'TRAILER';
    }
}

/**
 * Convert a duration to string
 */
const durationToStr = (sec_num, secs) => {
    const hours = Math.floor(sec_num / 3600);
    const minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    // const seconds = sec_num - (hours * 3600) - (minutes * 60);
    return hours.toString().padStart(2, '0') + 'h ' + minutes.toString().padStart(2, '0') + 'min';
};
/**
 * Convert a duration to string
 */
const durationToStrOld = (duration, secs) => {
    const pad = (num, size) => {
        return ('000' + num).slice(size * -1);
    };
    const hours = Math.floor(duration / 60 / 60);
    const minutes = Math.floor(duration / 60) % 60;
    let result = pad(hours, 2) + 'h ' + pad(minutes, 2) + 'min';
    if (secs) {
        const seconds = Math.floor(duration - minutes * 60);
        result += ' ' + pad(seconds, 2) + 's';
    }
    return result;
};
const durationToHoursStr = (duration) => {
    const hours = duration / 3600;
    return hours.toFixed(2);
};
const positionToURL = (lat, lng) => {
    return `<a href="http://maps.google.com/maps?q=${lat.toFixed(6)},${lng.toFixed(6)}&amp;t=m" target="_blank">${lat.toFixed(6)} °, ${lng.toFixed(6)} °</a>`;
};
const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) {
        return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};
function calcLuminance(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    const r = parseInt(result[1], 16);
    const g = parseInt(result[2], 16);
    const b = parseInt(result[3], 16);
    return (r * 0.299 + g * 0.587 + b * 0.114) / 256;
}
function romanize(num) {
    const digits = String(+num).split('');
    const key = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM',
        '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC',
        '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
    let roman = '';
    let i = 3;
    while (i--) {
        roman = (key[+digits.pop() + (i * 10)] || '') + roman;
    }
    return Array(+digits.join('') + 1).join('M') + roman;
}

class FieldIntervention extends BaseModel {
    constructor(data) {
        super(data);
        if (data.field && data.field_id) {
            this.field = new Field(data.field);
        }
        if (data.trailer && data.trailer_id) {
            this.trailer = new Trailer(data.trailer);
        }
        if (data.tractor && data.vehicle_id) {
            this.tractor = new Tractor(data.tractor);
        }
        switch (data.state) {
            case 'STARTED':
                this.stateText = 'Préparation';
                this.stateColor = 'yellow';
                break;
            case 'IN PROGRESS':
                this.stateText = 'En cours';
                this.stateColor = 'green';
                break;
            case 'ENDED':
                this.stateText = 'Finalisation';
                this.stateColor = 'orange';
                break;
            case 'TERMINATED':
                this.stateText = 'Terminée';
                this.stateColor = 'red';
                break;
            case 'ABORTED':
                this.stateText = 'Annulée';
                this.stateColor = 'red';
                break;
        }
        const lastTime = data.stop_time ? moment(data.stop_time).utc() : moment(data.update_time).utc();
        const diff = lastTime.diff(moment(this.start_time).utc(), 'seconds');
        this.startAgo = moment.duration(diff, 'seconds').humanize();
        if (this.working_area > 0) {
            this.workingAreaHa = this.working_area / 10000;
        }
        else {
            this.workingAreaHa = 0;
        }
        if (this.working_area > 0 && data.field && data.field.polygon_area > 0) {
            this.workingAreaPercent = this.working_area / data.field.polygon_area * 100;
        }
        else {
            this.workingAreaPercent = 0;
        }
        const fieldTotalDuration = this.working_in_field_idle_duration +
            this.working_in_field_off_duration + this.working_in_field_move_duration;
        this.workingAreaRate = this.workingAreaHa / (fieldTotalDuration / 60 / 60) || 0;
        this.durationStr = durationToHoursStr(diff);
    }
    toGeoJSON() {
        if (!this.working_multipolygon) {
            return null;
        }
        const mp = {
            type: 'MultiPolygon',
            coordinates: this.working_multipolygon
        };
        return new GeoJSON(mp);
    }
}

class TrailerInterventionMetrics {
    constructor(data) {
        this.engine_working_time = {};
        this.engine_working_hours = {};
        this.fuel_total_consumption = {};
        this.fuel_hourly_consumption_rate_avg = {};
        this.fuel_hourly_consumption_rate_avg_all = 0;
        this.fuel_temperature_avg = {};
        this.fuel_temperature_avg_all = 0;
        Object.assign(this, data);
        const cat = 'WORKING IN FIELD';
        this.engine_working_hours[cat] = this.engine_working_time[cat] / 3600;
        this.engine_working_time_all = this.engine_working_time[cat];
        this.engine_working_hours_all = this.engine_working_hours[cat];
        this.fuel_total_consumption_all = this.fuel_total_consumption[cat];
        this.fuel_hourly_consumption_rate_avg_all = this.fuel_hourly_consumption_rate_avg[cat];
        if (this.fuel_hourly_consumption_rate_avg_all) {
            this.fuel_hourly_consumption_rate_avg_all = this.fuel_total_consumption_all / this.engine_working_hours[cat];
        }
        this.fuel_temperature_avg_all = this.fuel_temperature_avg[cat];
    }
    constructor2(data) {
        Object.assign(this, data);
        Object.keys(this.engine_working_time || {}).forEach((v, k) => {
            this.engine_working_hours[v] = this.engine_working_time[v] / 3600;
        });
        this.engine_working_time_all = sum(values(this.engine_working_time));
        this.engine_working_hours_all = sum(values(this.engine_working_hours));
        this.fuel_total_consumption_all = sum(values(this.fuel_total_consumption));
        const l = Object.keys(this.fuel_hourly_consumption_rate_avg).length;
        if (this.fuel_hourly_consumption_rate_avg && l > 0) {
            this.fuel_hourly_consumption_rate_avg_all = sum(values(this.fuel_hourly_consumption_rate_avg)) / l;
        }
        const l2 = Object.keys(this.fuel_temperature_avg).length;
        if (this.fuel_temperature_avg && l2 > 0) {
            this.fuel_temperature_avg_all = sum(values(this.fuel_temperature_avg)) / l2;
        }
    }
}
class TrailerIntervention extends BaseModel {
    constructor(data) {
        super(data);
        if (data.field && data.field_id) {
            this.field = new Field(data.field);
        }
        if (data.trailer && data.trailer_id) {
            this.trailer = new Trailer(data.trailer);
        }
        if (data.tractor && data.vehicle_id) {
            this.tractor = new Tractor(data.tractor);
        }
        if (data.field_crop_name) {
            this.field_crop = new FieldCrop({
                name: data.field_crop_name,
                cadastral_area: data.field_crop_cadastral_area,
            });
        }
        if ((data === null || data === void 0 ? void 0 : data.crop_name) && (data === null || data === void 0 ? void 0 : data.crop_path)) {
            this.crop = new Crop({
                name: data.crop_name,
                path: data.crop_path
            });
        }
        switch (data.state) {
            case 'STARTED':
                this.stateText = 'Préparation';
                this.stateColor = 'yellow';
                break;
            case 'IN PROGRESS':
                this.stateText = 'En cours';
                this.stateColor = 'green';
                break;
            case 'ENDED':
                this.stateText = 'Finalisation';
                this.stateColor = 'orange';
                break;
            case 'TERMINATED':
                this.stateText = 'Terminée';
                this.stateColor = 'red';
                break;
            case 'ABORTED':
                this.stateText = 'Annulée';
                this.stateColor = 'red';
                break;
        }
        const lastTime = data.stop_time ? moment(data.stop_time).utc() : moment(data.update_time).utc();
        const diff = lastTime.diff(moment(this.start_time).utc(), 'seconds');
        this.startAgo = moment.duration(diff, 'seconds').humanize();
        if (this.working_area > 0) {
            this.workingAreaHa = this.working_area / 10000;
        }
        else {
            this.workingAreaHa = 0;
        }
        if (this.working_area > 0 && data.field && data.field.polygon_area > 0) {
            this.workingAreaPercent = this.working_area / data.field.polygon_area * 100;
        }
        else {
            this.workingAreaPercent = 0;
        }
        const fieldTotalDuration = this.working_in_field_idle_duration +
            this.working_in_field_off_duration + this.working_in_field_move_duration;
        this.workingAreaRate = this.workingAreaHa / (fieldTotalDuration / 60 / 60) || 0;
        this.durationStr = durationToHoursStr(diff);
        this.metrics = new TrailerInterventionMetrics(this.metrics);
    }
    hasOperationsRules() {
        return this.trailer_operation_type_rules && this.trailer_operation_type_rules.max_speed > 0 && this.trailer_operation_type_rules.min_speed > 0;
    }
    toGeoJSON() {
        if (!this.working_multipolygon_geojson) {
            return null;
        }
        /*const mp: MultiPolygon = {
          type: 'MultiPolygon',
          coordinates: this.working_multipolygon
        };*/
        return new GeoJSON(this.working_multipolygon_geojson);
    }
}

class TrailerInterventionStatus {
    constructor(data) {
        Object.assign(this, data);
        switch (data.state) {
            case 'STARTED':
                this.stateText = 'Préparation';
                this.stateColor = 'yellow';
                break;
            case 'IN PROGRESS':
                this.stateText = 'En cours';
                this.stateColor = 'green';
                break;
            case 'ENDED':
                this.stateText = 'Finalisation';
                this.stateColor = 'orange';
                break;
            case 'TERMINATED':
                this.stateText = 'Terminée';
                this.stateColor = 'red';
                break;
            case 'ABORTED':
                this.stateText = 'Annulée';
                this.stateColor = 'red';
                break;
        }
        const diff = moment().utc().diff(moment(this.start_time));
        this.startAgo = moment.duration(diff).humanize();
        if (this.working_area > 0) {
            this.workingAreaHa = (this.working_area / 10000).toFixed(1) + ' Ha';
        }
        else {
            this.workingAreaHa = ' - ';
        }
        if (this.working_area > 0 && this.field_area && this.field_area > 0) {
            this.workingAreaPercent = (this.working_area / this.field_area * 100).toFixed(1) + ' %';
        }
        else {
            this.workingAreaPercent = '-';
        }
    }
    finished() {
        return this.state === 'ABORTED' || this.state === 'TERMINATED';
    }
    durationHours(name) {
        if (this.hasOwnProperty(name)) {
            return durationToHoursStr(this[name]);
        }
    }
    durationHTML(name) {
        if (!this.hasOwnProperty(name)) {
            return 'NA';
        }
        return `<span title="${durationToStr(this[name])}">${durationToHoursStr(this[name])} h</span>`;
    }
}

const allMessages = new Map();
allMessages.set('OVER_SPEED', 'Excès de vitesse #speed# km/h (vitesse maximale #maxSpeed# km/h)');
allMessages.set('UNDER_SPEED', 'Abaissement de vitesse #speed# km/h (vitesse minimale #minSpeed# km/h)');
class TrailerInterventionAlert extends BaseModel {
    constructor(data) {
        super(data);
        this.message = allMessages.get(this.type);
        if (!this.message) {
            return;
        }
        Object.keys(this.variables).forEach(key => {
            this.message = this.message.replace(`#${key}#`, this.variables[key]);
        });
    }
}

class FuelLevel {
    constructor(obj) {
        Object.assign(this, obj);
    }
}
class FuelConsumption {
    constructor(obj) {
        Object.assign(this, obj);
        this.levels = obj.levels.map(p => new FuelLevel(p));
    }
    fillings() {
        const levels = [];
        let last = null;
        for (const l of this.levels) {
            if (l.diff > 0) {
                if (last !== null) {
                    last.diff += l.diff;
                }
                else {
                    last = l;
                }
            }
            else {
                if (last !== null && last.diff > 5) {
                    levels.push(last);
                }
                last = null;
            }
        }
        if (last !== null && last.diff > 5) {
            levels.push(last);
        }
        return levels;
    }
    thefts() {
        const levels = [];
        let last = null;
        for (const l of this.levels) {
            if (l.diff > 0) {
                if (last !== null) {
                    last.diff += l.diff;
                }
                else {
                    last = l;
                }
            }
            else {
                if (last !== null && last.diff > 5) {
                    levels.push(last);
                }
                last = null;
            }
        }
        if (last !== null && last.diff > 5) {
            levels.push(last);
        }
        return levels;
    }
    toFixed(fix) {
        return this.total.toFixed(2);
    }
    perHour(hours) {
        return this.total / hours;
    }
}

class Packet {
    constructor(obj) {
        Object.assign(this, obj);
    }
    acc() {
        return this.isINActive(5);
    }
    isINActive(index) {
        // tslint:disable-next-line:no-bitwise
        return (this.in & (1 << (index - 1))) !== 0;
    }
    state() {
        if (this.tracker_time === null) {
            return TrackerState.Offline;
        }
        if (this.acc() && this.speed > 0) {
            return TrackerState.Moving;
        }
        else if (this.acc() && this.speed === 0) {
            return TrackerState.Idle;
        }
        else {
            return TrackerState.Stopped;
        }
    }
    /**
     * Get record position as Lng, Lat
     */
    coords() {
        return [this.lng, this.lat];
    }
    gMapURL() {
        return positionToURL(this.lat, this.lng);
    }
    date() {
        return this.tracker_time;
    }
}

class RouteParams {
    constructor(min_stop_duration) {
        this.min_stop_duration = min_stop_duration;
    }
}
class RouteLoader {
    constructor() {
        this.loaded = 0;
        this._loading = new Subject();
        this.loading$ = this._loading.asObservable();
    }
    loadedStr() {
        if (this.loaded === 0) {
            return 'Chargement...';
        }
        return formatBytes(this.loaded || 0, 2);
    }
    totalStr() {
        return formatBytes(this.total || 0, 2);
    }
    startLoading() {
        this._loading.next(true);
    }
    endLoading() {
        this._loading.next(false);
    }
    isEmpty() {
        return !this.route || this.route.data.length === 0;
    }
}
class Route {
    constructor(obj) {
        Object.assign(this, obj);
        this.data = obj.data.map(p => new Packet(p));
        if (obj.fuel_consumption) {
            this.fuel_consumption = new FuelConsumption(obj.fuel_consumption);
        }
    }
    lengthStr() {
        return (this.length / 1000).toFixed(2);
    }
    fuelConsumptionStr() {
        return this.fuel_consumption.toFixed(2).toString();
    }
    maximumTemperatureStr() {
        return this.maximum_temperature.toFixed(2);
    }
    minimumTemperatureStr() {
        return this.minimum_temperature.toFixed(2);
    }
    maximumHumidityStr() {
        return this.maximum_humidity.toFixed(2);
    }
    minimumHumidityStr() {
        return this.minimum_humidity.toFixed(2);
    }
    fuelConsumptionPerHourStr() {
        return this.fuel_consumption.perHour(this.drives_duration / 3600).toFixed(2);
        //return this.fuel_consumption.perHour(this.drives_duration / 3600).toFixed(2).toString();
    }
    stopsDurationStr() {
        return durationToHoursStr(this.stops_duration);
    }
    drivesDurationStr() {
        return durationToHoursStr(this.drives_duration);
    }
    engineWorkTimeStr() {
        return this.engine_work_time.toFixed(2);
        // return this.engine_work_time?.toFixed(2);
    }
    engineIdleTimeStr() {
        return this.engine_idle_time.toFixed(2);
    }
    layer(options) {
        // Construct the layer
        const geo = new GeoJSON({
            type: 'Feature',
            geometry: {
                type: 'LineString',
                coordinates: this.data.map(r => r.coords())
            },
            properties: {
                coordTimes: this.data.map(r => moment(r.tracker_time).format('YYYY-MM-DD HH:mm:ss'))
            }
        });
        geo.setStyle(options || {
            color: '#ff0000',
            weight: 3,
            opacity: 1
        });
        return geo;
    }
}

class FlowMeterDataLoader {
    constructor() {
        this.loaded = 0;
        this._loading = new Subject();
        this.loading$ = this._loading.asObservable();
    }
    loadedStr() {
        if (this.loaded === 0) {
            return 'Chargement...';
        }
        return formatBytes(this.loaded || 0, 2);
    }
    totalStr() {
        return formatBytes(this.total || 0, 2);
    }
    startLoading() {
        this._loading.next(true);
    }
    endLoading() {
        this._loading.next(false);
    }
    isEmpty() {
        return !this.data || this.data.data.length === 0;
    }
}
class FlowMeterBatchDataLoader {
    constructor() {
        this.loaded = 0;
        this._loading = new Subject();
        this.loading$ = this._loading.asObservable();
    }
    loadedStr() {
        if (this.loaded === 0) {
            return 'Chargement...';
        }
        return formatBytes(this.loaded || 0, 2);
    }
    totalStr() {
        return formatBytes(this.total || 0, 2);
    }
    startLoading() {
        this._loading.next(true);
    }
    endLoading() {
        this._loading.next(false);
    }
    isEmpty() {
        return !this.data || this.data.every(i => !i.data || i.data.length === 0);
    }
}
class FlowMeterEntry {
    constructor(obj) {
        Object.assign(this, obj);
        this.fuel_hr_total_consumption *= 0.001;
        this.fuel_hr_total_consumption_diff *= 0.001;
        this.fuel_hourly_consumption_rate *= 0.05;
    }
}
class FlowMeterData {
    constructor(obj) {
        Object.assign(this, obj);
        this.data = obj.data.map(e => new FlowMeterEntry(e));
        this.fuel_hr_total_consumption *= 0.001;
        this.fuel_hourly_consumption_rate_avg *= 0.05;
        this.engine_working_hours = this.engine_working_time / 3600;
        this.engine_hours_str = durationToHoursStr(this.engine_working_time);
    }
}

const modules = new Map([
    ...defaultModules,
]);
const notificationStack = new Stack({
    dir1: 'up',
    dir2: 'left',
    firstpos1: 15,
    firstpos2: 15,
    modal: false,
    maxOpen: 2,
});
const TRAILER_INTERVENTION_OVER_SPEED_NOTIFICATION = 'TRAILER_INTERVENTION_OVER_SPEED';
const TRAILER_INTERVENTION_UNDER_SPEED_NOTIFICATION = 'TRAILER_INTERVENTION_UNDER_SPEED';
const notifications = new Map([
    [TRAILER_INTERVENTION_OVER_SPEED_NOTIFICATION, {
            type: 'notice',
            title: 'Excès de vitesse',
            text: 'Excès de vitesse #tractorName# #speed# km/h',
        }],
    [TRAILER_INTERVENTION_UNDER_SPEED_NOTIFICATION, {
            type: 'notice',
            title: 'Abaissement de vitesse',
            text: 'Abaissement de vitesse #tractorName# #speed# km/h',
        }],
]);
class Notification extends BaseModel {
    constructor(data) {
        super(data);
        this.properties = notifications.get(this.type);
        const diff = moment(this.time).diff(moment().utc());
        this.ago = moment.duration(diff).humanize(true);
        this.message = this.properties.text;
        if (!this.message) {
            return;
        }
        Object.keys(this.variables).forEach(key => {
            this.message = this.message.replace(`#${key}#`, this.variables[key]);
        });
    }
    show(click) {
        const a = alert({
            type: this.properties.type,
            // title: this.properties.title,
            text: this.message,
            mode: 'light',
            stack: notificationStack,
            modules,
        });
        if (click) {
            a.refs.elem.style.cursor = 'pointer';
            a.on('click', e => {
                // @ts-ignore
                if ([...a.refs.elem.querySelectorAll('.pnotify-closer *, .pnotify-sticker *')].indexOf(e.target) !== -1) {
                    return;
                }
                click(a);
            });
        }
    }
}

const tagTypes = [
    { id: 100, name: 'RFID' },
    { id: 200, name: 'BLE' },
];
const tagCategories = [
    { id: 10, name: 'Intervention Outils' },
    { id: 20, name: 'Intervention Machines' },
    { id: 30, name: 'Intervention Transport' },
    { id: 40, name: 'Identification Chauffeur' },
];
const taggableTypeTagCategories = new Map([
    ['TRAILER', [
            { id: 10, name: 'Intervention Outils' },
            { id: 30, name: 'Intervention Transport' },
        ]],
    ['DRIVER', [
            { id: 40, name: 'Identification Chauffeur' },
        ]],
]);
class Tag extends BaseModel {
    constructor(data) {
        super(data);
        this.attributes = this.attributes ? this.attributes.map(p => new TagAttribute(p)) : [];
    }
}
class TagAttribute extends BaseModel {
}
class TagDetails {
    constructor(data) {
        Object.assign(this, data);
    }
}

class Poi extends BaseModel {
    constructor(data) {
        super(data);
        if (!this.category_id) {
            this.category = 'Non classés';
        }
    }
    get geojson() {
        if (!this._geojson) {
            this._geojson = parse(this.geometry);
        }
        return this._geojson;
    }
    set geojson(value) {
        this.geometry = convert(value);
        this._geojson = value;
    }
    get layer() {
        if (!this._layer) {
            this._layer = this.createLayer();
        }
        return this._layer;
    }
    set layer(value) {
        this._layer = value;
    }
    createLayer() {
        let layer;
        if (this.type === 'POLYGON') {
            layer = polygon(GeoJSON.coordsToLatLngs(this.geojson.coordinates, 1), {
                color: this.color,
                weight: 1,
            });
        }
        else if (this.type === 'POINT') {
            const point = this.geojson.coordinates;
            // @ts-ignore
            const redMarker = ExtraMarkers.icon({
                icon: 'circle',
                iconColor: calcLuminance(this.color) > 0.85 ? 'dimgray' : 'white',
                // @ts-ignore
                markerColor: this.color,
                shape: 'circle',
                svg: true,
                prefix: 'icon'
            });
            layer = marker([point[1], point[0]], {
                icon: redMarker,
            });
        }
        return layer;
    }
    cloneLayer() {
        return this.createLayer();
    }
    getBounds() {
        if (this.type === 'POLYGON') {
            return this.layer.getBounds();
        }
        else if (this.type === 'POINT') {
            return this.layer.getLatLng().toBounds(3000);
        }
    }
}
class PoiCategory extends BaseModel {
}

class TransportIntervention extends BaseModel {
    constructor(data) {
        super(data);
        this.metrics = new TransportInterventionMetrics(this.metrics);
        this.tag_details = new TagDetails(this.tag_details);
        this.endpoints = new TransportInterventionEndpoints(this.endpoints);
        const now = new Date();
        this.start_time = new Date(data.start_time);
        this.stop_time = data.stop_time ? new Date(data.stop_time) : null;
        if (this.stop_time) {
            this.duration = (this.stop_time.getTime() - this.start_time.getTime()) / 1000;
        }
        else {
            this.duration = (now.getTime() - this.start_time.getTime()) / 1000;
        }
        this.duration_human = durationToStr(this.duration);
    }
}
class TransportInterventionMetrics {
    constructor(data) {
        this.length = 0;
        this.fuel_consumption = 0;
        this.engine_working_time = 0;
        this.engine_working_hours = 0;
        this.length_in_km = 0;
        this.speed_avg = 0;
        this.speed_max = 0;
        this.fuel_total_consumption = 0;
        this.fuel_hourly_consumption_rate_avg = 0;
        this.fuel_temperature_avg = 0;
        Object.assign(this, data);
        this.engine_working_hours = this.engine_working_time / 3600;
        this.length_in_km = this.length / 1000;
    }
    diff(other) {
        return {
            length: this.length - other.length,
            fuel_total_consumption: this.fuel_total_consumption - other.fuel_total_consumption,
            engine_working_time: this.engine_working_time - other.engine_working_time,
            engine_working_hours: this.engine_working_hours - other.engine_working_hours,
            length_in_km: this.length_in_km - other.length_in_km,
            speed_avg: this.speed_avg,
            speed_max: this.speed_max,
            fuel_hourly_consumption_rate_avg: this.fuel_hourly_consumption_rate_avg,
            fuel_temperature_avg: this.fuel_temperature_avg,
        };
    }
}
class TransportInterventionDashboardMetrics extends TransportInterventionMetrics {
}
class TransportInterventionEndpoints extends BaseModel {
    constructor(data) {
        super(data);
        this.roundTrips = this.total_visits / 2;
        this.first_poi_visits_duration_str = durationToStr(this.first_poi_visits_duration);
        this.first_poi_visits_duration_hours_str = durationToHoursStr(this.first_poi_visits_duration);
        this.second_poi_visits_duration_str = durationToStr(this.second_poi_visits_duration);
        this.second_poi_visits_duration_hours_str = durationToHoursStr(this.second_poi_visits_duration);
    }
}
class TransportInterventionRealtime {
    constructor(data) {
        Object.assign(this, data);
        this.previous_poi_duration_human = moment.duration(this.previous_poi_duration, 'minutes').humanize();
        this.current_poi_duration_human = moment.duration(this.current_poi_duration, 'minutes').humanize();
    }
}

class TransportInterventionPoi extends BaseModel {
    constructor(data) {
        super(data);
        this.visit_duration = 0;
        this.enter_time = moment(this.enter_time).toDate();
        // Duration
        if (this.exit_time) {
            this.exit_time = moment(this.exit_time).toDate();
            this.visit_duration = (this.exit_time.getTime() - this.enter_time.getTime()) / 1000;
        }
        else {
            this.visit_duration = (moment().toDate().getTime() - this.enter_time.getTime()) / 1000;
        }
        this.poi = new Poi(this.poi);
        this.metrics = new TransportInterventionMetrics(this.metrics);
        this.visit_duration_human = moment.duration(this.visit_duration, 'minutes').humanize();
    }
}
const transportInterventionPoiListReport = (list) => {
    const report = {};
    // Sort by date
    list.sort(function compare(a, b) {
        return a.enter_time.getTime() - b.enter_time.getTime();
    });
    // Calc diffs
    for (let i = 0; i < list.length; i++) {
        const tPoi = list[i];
        // Diff metrics
        if (i > 0) {
            tPoi.diff_metrics = tPoi.metrics.diff(list[i - 1].metrics);
        }
        else {
            tPoi.diff_metrics = Object.assign({}, tPoi.metrics);
        }
        if (!report.hasOwnProperty(tPoi.poi_id)) {
            report[tPoi.poi_id] = {
                name: tPoi.poi.name,
                length: tPoi.diff_metrics.length,
                fuel_total_consumption: tPoi.diff_metrics.fuel_total_consumption,
                engine_working_time: tPoi.diff_metrics.engine_working_time,
                visit_duration: tPoi.visit_duration,
            };
        }
        else {
            const tPoiReport = report[tPoi.poi_id];
            tPoiReport.visit_duration += tPoi.visit_duration;
            tPoiReport.length += tPoi.diff_metrics.length;
            tPoiReport.fuel_total_consumption += tPoi.diff_metrics.fuel_total_consumption;
            tPoiReport.engine_working_time += tPoi.diff_metrics.engine_working_time;
        }
    }
    return Object.values(report);
};
class TransportInterventionPoiGroupReport {
    constructor(data) {
        Object.assign(this, data);
        this.visit_duration_human = moment.duration(this.visit_duration, 'minutes').humanize();
    }
}
/**
 * Group the list by id and summary each poi
 * @param list poi list
 */
const transportInterventionPoiDiffAndGroupReport = (list) => {
    // Sort by date
    list.sort(function compare(a, b) {
        return a.enter_time.getTime() - b.enter_time.getTime();
    });
    list[0].diff_metrics = Object.assign({}, list[0].metrics);
    list[0].visit_number = 1;
    // Calc Diff metrics
    for (let i = 1; i < list.length; i++) {
        list[i].diff_metrics = list[i].metrics.diff(list[i - 1].metrics);
        list[i].visit_number = i + 1;
    }
    const groups = groupBy(list, 'poi_id');
    const report = [];
    for (const id of Object.keys(groups)) {
        report.push(new TransportInterventionPoiGroupReport({
            poi: groups[id][0].poi,
            nb_visits: groups[id].length,
            visit_duration: groups[id].reduce((sum, i) => {
                return sum + i.visit_number;
            }, 0),
            visits_numbers: groups[id].reduce((str, i) => {
                return str + ', #' + i.visit_number;
            }, ''),
            metrics: sumTransportInterventionPoiMetricsGroup(groups[id]),
            visits: groups[id],
        }));
    }
    return report;
};
function sumTransportInterventionPoiMetricsGroup(group) {
    const metrics = new TransportInterventionMetrics({});
    metrics.speed_max = group[0].metrics.speed_max;
    for (const tPoi of group) {
        metrics.length += tPoi.diff_metrics.length;
        metrics.length_in_km += tPoi.diff_metrics.length_in_km;
        metrics.engine_working_time += tPoi.diff_metrics.engine_working_time;
        metrics.engine_working_hours += tPoi.diff_metrics.engine_working_hours;
        metrics.fuel_total_consumption += tPoi.diff_metrics.fuel_total_consumption;
        metrics.fuel_temperature_avg += tPoi.diff_metrics.fuel_temperature_avg;
        metrics.fuel_hourly_consumption_rate_avg += tPoi.diff_metrics.fuel_hourly_consumption_rate_avg;
        if (tPoi.diff_metrics.speed_max > metrics.speed_max) {
            metrics.speed_max = tPoi.diff_metrics.speed_max;
        }
        metrics.speed_avg += tPoi.diff_metrics.speed_avg;
    }
    metrics.speed_avg /= group.length;
    metrics.fuel_temperature_avg /= group.length;
    metrics.fuel_hourly_consumption_rate_avg /= group.length;
    return metrics;
}

class TransportInterventionsStatus {
    constructor(data) {
        this.tag_attributes = [];
        Object.assign(this, data);
        switch (data.state) {
            case 'STARTED':
                this.stateText = 'Préparation';
                this.stateColor = 'yellow';
                break;
            case 'IN PROGRESS':
                this.stateText = 'En cours';
                this.stateColor = 'green';
                break;
            case 'ENDED':
                this.stateText = 'Finalisation';
                this.stateColor = 'orange';
                break;
            case 'TERMINATED':
                this.stateText = 'Terminée';
                this.stateColor = 'red';
                break;
            case 'ABORTED':
                this.stateText = 'Annulée';
                this.stateColor = 'red';
                break;
        }
        this.start_time = new Date(data.start_time);
        this.stop_time = new Date(data.stop_time);
        const diff = moment().diff(moment(this.start_time));
        this.startAgo = moment.duration(diff, 'minutes').humanize();
        this.tag_attributes = this.tag_attributes ? this.tag_attributes.map(p => new TagAttribute(p)) : [];
        this.metrics = new TransportInterventionMetrics(this.metrics);
        this.realtime = new TransportInterventionRealtime(this.realtime);
        const now = new Date();
        if (this.realtime.previous_poi_exit_time) {
            this.last_stop_elapsed_duration = (now.getTime() - this.realtime.previous_poi_exit_time.getTime()) / 1000;
        }
        else {
            this.last_stop_elapsed_duration = (now.getTime() - this.start_time.getTime()) / 1000;
        }
        this.last_stop_elapsed_duration_human = moment.duration(this.last_stop_elapsed_duration, 'minutes').humanize();
        this.duration = (now.getTime() - this.start_time.getTime()) / 1000;
        this.duration_human = moment.duration(this.duration, 'minutes').humanize();
    }
    finished() {
        return this.state === 'ABORTED' || this.state === 'TERMINATED';
    }
    tagAttrValue(name, defaultValue) {
        const attr = this.tag_attributes.find((a) => a.name === name);
        return attr ? attr.value : defaultValue;
    }
}

class Driver extends BaseModel {
    photoUrl() {
        if (this.photo === null) {
            return 'assets/images/profile.png';
        }
        return this.photo;
    }
    get taggable_domain_id() {
        return this.domain_id;
    }
    get taggable_id() {
        return this.id;
    }
    get taggable_name() {
        return this.name;
    }
    get taggable_properties() {
        return null;
    }
    get taggable_type() {
        return 'DRIVER';
    }
}

class CropCategory extends BaseModel {
}

class SensorSettings {
}
class Sensor extends BaseModel {
    constructor(data) {
        super(data);
        this.history = data.history ? data.history.map(h => new SensorRecord(h)) : [];
        this.changes = data.changes ? data.changes.map(h => new SensorValueChange(h)) : [];
    }
}
class SensorRecord {
    constructor(data) {
        Object.assign(this, data);
    }
}
class SensorValueChange {
    constructor(data) {
        Object.assign(this, data);
    }
}
class SensorHistoryLoader {
    constructor() {
        this.loaded = 0;
        this._loading = new Subject();
        this.loading$ = this._loading.asObservable();
    }
    loadedStr() {
        if (this.loaded === 0) {
            return 'Chargement...';
        }
        return formatBytes(this.loaded || 0, 2);
    }
    totalStr() {
        return formatBytes(this.total || 0, 2);
    }
    startLoading() {
        this._loading.next(true);
        this.isLoaded = false;
    }
    endLoading() {
        this._loading.next(false);
        this.isLoaded = true;
    }
    isEmpty() {
        return !this.sensor || this.sensor.history.length === 0;
    }
}

class Tank extends BaseModel {
    constructor(data) {
        super(data);
        this.sensors = this.sensors ? this.sensors.map(p => new Sensor(p)) : [];
    }
}

class ThirdpartySystemResourceTypeFields {
    constructor(data) {
        Object.assign(this, data);
    }
    toColumns(parent, root) {
        const columns = [];
        if (!this.fields) {
            return columns;
        }
        this.fields.forEach((sf) => {
            const column = Object.assign({}, sf, {
                dataField: `${root}.${this.name}.${sf.dataField}`,
                caption: sf.label.text,
            });
            this.setupValidationRules(parent, sf);
            columns.push(column);
        });
        return columns;
    }
    setupValidationRules(parent, sf) {
        if (!isArray(sf.validationRules)) {
            return;
        }
        sf.validationRules.forEach(rule => {
            if (rule.type === 'async' && rule.hasOwnProperty('validationCallback')) {
                if (isFunction(parent[rule.validationCallback])) {
                    rule.validationCallback = bind(parent[rule.validationCallback], parent, bind.placeholder, this.name, sf.dataField);
                }
                else {
                    rule.validationCallback = new Promise((resolve) => {
                        resolve(true);
                    });
                }
            }
        });
    }
}
class ThirdpartySystem extends BaseModel {
}

class Setting extends BaseModel {
}

class Ticket {
    constructor(data) {
        Object.assign(this, data);
    }
}
class TicketsComment {
    constructor(data) {
        Object.assign(this, data);
    }
}
class TicketsComments {
    constructor(data) {
        Object.assign(this, data);
    }
}

class FieldsRBush extends RBush {
    toBBox(item) {
        return item.bbox;
    }
    compareMinX(a, b) {
        return a.bbox.minX - b.bbox.minX;
    }
    compareMinY(a, b) {
        return a.bbox.minY - b.bbox.minY;
    }
    remove(item) {
        return super.remove(item, (a, b) => {
            return a.id === b.id;
        });
    }
}

/**
 * Route Tag icon
 */
class RouteTagRow {
    constructor(tag, icon, time, information) {
        this.tag = tag;
        this.icon = icon;
        this.time = time;
        this.information = information;
    }
}
/**
 * Route tagging of single record
 */
class RouteTag {
    /**
     * Show Tag on map init!
     */
    visibleOnMap() {
        return true;
    }
    /**
     * Access Layer
     */
    get layer() {
        return this._layer;
    }
    set layer(value) {
        this._layer = value;
    }
    renderProperties() {
        const props = this.properties();
        let html = '';
        if (props.hasOwnProperty('title')) {
            // @ts-ignore
            html = '<div class="route-layer-title">' + props.title + '</div>';
        }
        html += '<div class="route-layer-popup details-list">';
        Object.keys(props).forEach(key => {
            html += this.renderProperty(key, props[key], html);
        });
        html += '</div>';
        return html;
    }
    renderProperty(key, prop, html) {
        switch (typeof prop) {
            case 'function':
                return prop(key, html);
            default:
                return '<div class="head">' + key + ': </div> <div>' + prop + '</div>';
        }
    }
}
/**
 * Route tagging of single gps packet
 */
class RouteSingleTag extends RouteTag {
    constructor(packet) {
        super();
        this.packet = packet;
        this.time = this.packet.date();
    }
    addToMap(layer) {
        // Tag icon
        const icon$1 = icon({
            iconUrl: this.icon(),
            iconSize: [28, 28],
            iconAnchor: [14, 28]
        });
        // Create layer
        this.layer = new Marker([this.packet.lat, this.packet.lng], { icon: icon$1 });
        // Bind popup
        // this.layer.bindPopup(this.renderProperties(), {
        this.layer.bindPopup(() => {
            const popupEl = document.createElement('route-marker-popup');
            popupEl.props = this.properties();
            return popupEl;
        }, {
            offset: [0, -20],
            minWidth: 300,
        });
        // Add to parent layer
        this.layer.addTo(layer);
    }
    /**
     * Get tag bounds
     */
    getBounds() {
        return [[this.packet.lat, this.packet.lng], [this.packet.lat, this.packet.lng]];
    }
}
/**
 * Route start tag
 */
class RouteStartTag extends RouteSingleTag {
    icon() {
        return '/assets/icons/route-start.svg';
    }
    properties() {
        return {
            Position: this.packet.gMapURL(),
            Altitude: this.packet.altitude + ' m',
            Angle: this.packet.angle + ' °',
            Date: moment(this.time).format('YYYY-MM-DD HH:mm:ss'),
        };
    }
    type() {
        return 'start';
    }
    gridRow() {
        return new RouteTagRow(this, this.icon(), this.time, '');
    }
}
/**
 * Route end tag
 */
class RouteEndTag extends RouteSingleTag {
    icon() {
        return '/assets/icons/route-end.svg';
    }
    properties() {
        return {
            Position: this.packet.gMapURL(),
            Altitude: this.packet.altitude + ' m',
            Angle: this.packet.angle + ' °',
            Date: moment(this.time).format('YYYY-MM-DD HH:mm:ss'),
        };
    }
    type() {
        return 'end';
    }
    gridRow() {
        return new RouteTagRow(this, this.icon(), this.time, '');
    }
}
/**
 * Route end tag
 */
class RoutePacketTag extends RouteSingleTag {
    icon() {
        return '/assets/icons/route-data-packet.svg';
    }
    properties() {
        return {
            Position: this.packet.gMapURL(),
            Altitude: this.packet.altitude + ' m',
            Angle: this.packet.angle + ' °',
            Date: moment(this.time).format('YYYY-MM-DD HH:mm:ss'),
        };
    }
    type() {
        return 'packet';
    }
    gridRow() {
        return new RouteTagRow(this, this.icon(), this.time, '');
    }
}
/**
 * Route tagging of a sequence of records
 */
class RouteSequenceTag extends RouteTag {
    /**
     * Create new sequence tag with the first record
     * @param first the first record
     */
    constructor(first) {
        super();
        this.packets = [];
        this.size = 0;
        this.duration = 0;
        this.startTime = first.date();
        this.packets.push(first);
        this.size++;
    }
    /**
     * Add new packet to the sequence
     * @param packet gps packet
     */
    append(packet) {
        this.endTime = packet.date();
        this.duration += (packet.date().getTime() - this.packets[this.size - 1].date().getTime()) / 1000;
        this.packets.push(packet);
        this.size++;
    }
    /**
     * Append the last record
     * @param last the last record
     */
    appendLast(last) {
        this.endTime = last.date();
        this.duration += (last.date().getTime() - this.packets[this.size - 1].date().getTime()) / 1000;
    }
    /**
     * Convert a duration to string
     */
    durationToStr() {
        return durationToStr(this.duration, true);
    }
}
/**
 * Route stop tag
 */
class RouteStopTag extends RouteSequenceTag {
    constructor(first) {
        super(first);
    }
    type() {
        return 'stop';
    }
    icon() {
        return '/assets/icons/route-stop.svg';
    }
    properties() {
        const record = this.packets[0];
        return {
            Position: positionToURL(record.lat, record.lng),
            Altitude: record.altitude + ' m',
            Angle: record.angle + ' °',
            Entré: moment(this.startTime).format('YYYY-MM-DD HH:mm:ss'),
            Quitté: moment(this.endTime).format('YYYY-MM-DD HH:mm:ss'),
            Durée: this.durationToStr()
        };
    }
    addToMap(layer) {
        const icon$1 = icon({
            iconUrl: this.icon(),
            iconSize: [28, 28],
            iconAnchor: [14, 28]
        });
        this.layer = new Marker([this.packets[0].lat, this.packets[0].lng], { icon: icon$1 });
        this.layer.bindPopup(() => {
            const popupEl = document.createElement('route-marker-popup');
            popupEl.props = this.properties();
            return popupEl;
        }, {
            offset: [0, -20],
            minWidth: 300,
        });
        this.layer.addTo(layer);
    }
    gridRow() {
        return new RouteTagRow(this, this.icon(), this.startTime, this.durationToStr());
    }
    /**
     * Get tag bounds
     */
    getBounds() {
        return [[this.packets[0].lat, this.packets[0].lng], [this.packets[0].lat, this.packets[0].lng]];
    }
}
/**
 * Route drive tag
 */
class RouteDriveTag extends RouteSequenceTag {
    constructor(first) {
        super(first);
        this._length = 0;
    }
    type() {
        return 'drive';
    }
    icon() {
        return '/assets/icons/route-drive.svg';
    }
    properties() {
        return {
            length: this.length,
        };
    }
    addToMap(map) {
        this.layer = geoJSON(this.lineString, {
            style: {
                color: '#0099ff',
                weight: 4,
                opacity: 1
            }
        }).addTo(map);
        map.fitBounds(this.bounds, {
            padding: [20, 20],
            animate: true,
        });
    }
    /**
     * Don't show drive segments on start
     */
    visibleOnMap() {
        return false;
    }
    /**
     * Merge with another sequence
     * @param entry the sequence
     */
    merge(entry) {
        this.packets.push(...entry.packets);
        this.duration += entry.duration;
        this.size += entry.size;
        this.endTime = entry.endTime;
    }
    get line() {
        if (!this._line) {
            this._line = lineString(this.packets.map((r) => r.coords()));
        }
        return this._line;
    }
    get length() {
        if (this._length === 0) {
            this._length = length(this.line);
        }
        return this._length;
    }
    gridRow() {
        return new RouteTagRow(this, this.icon(), this.startTime, this.durationToStr());
    }
    /**
     * Get tag bounds
     */
    getBounds() {
        return this.bounds;
    }
    get lineString() {
        if (!this._lineString) {
            this._lineString = {
                type: 'Feature',
                geometry: {
                    type: 'LineString',
                    coordinates: this.packets.map(r => r.coords())
                }
            };
        }
        return this._lineString;
    }
    get bounds() {
        if (!this._bounds) {
            const [lng1, lat1, lng2, lat2] = bbox(this.lineString);
            this._bounds = [[lat1, lng1], [lat2, lng2]];
        }
        return this._bounds;
    }
}
class LocalLayer {
    constructor(visible) {
        this.visible = visible;
    }
}
/**
 * Route tags timeline
 */
class RouteTimeline {
    constructor(map, route, routeParams) {
        this.tags = [];
        this.layerGroups = new Map();
        this.map = map;
        this.route = route;
        this.routeParams = routeParams;
        this.parseTags();
    }
    createTags(packet) {
        let newSequence;
        const tags = [];
        if (packet.state() === TrackerState.Moving) {
            newSequence = new RouteDriveTag(packet);
        }
        else {
            newSequence = new RouteStopTag(packet);
        }
        /*if (record.events && record.events.length > 0) {
          record.events.forEach((event) => {
            tags.push(new RouteEventTag(record, event));
          });
        }*/
        return [newSequence, tags];
    }
    parseTags() {
        const tmpTags = [];
        this.route.data.forEach((packet) => {
            const [newSequence, tags] = this.createTags(packet);
            // If there is nothing
            if (tmpTags.length === 0) {
                // Update the last sequence
                this.lastSequence = newSequence;
                // Add the new sequence
                tmpTags.push(newSequence);
                tmpTags.push(...tags);
                return;
            }
            if (this.lastSequence.type() !== newSequence.type()) {
                // The new sequence record first record is the last record of the previous sequence
                this.lastSequence.appendLast(packet);
                // Add the new sequence
                tmpTags.push(newSequence);
                // Update the last sequence
                this.lastSequence = newSequence;
            }
            else {
                this.lastSequence.append(packet);
            }
            tmpTags.push(...tags);
        });
        // Reset the last sequence
        this.lastSequence = null;
        this.tags.push(new RouteStartTag(this.route.data[0]));
        // Filter short stop durations
        tmpTags.forEach((tag) => {
            if (tag instanceof RouteSequenceTag) {
                if (this.lastSequence &&
                    this.lastSequence.type() === 'drive' &&
                    (this.lastSequence.type() === tag.type() || tag.duration < this.routeParams.min_stop_duration)) {
                    this.lastSequence.merge(tag);
                }
                else {
                    // Insert the new sequence
                    this.tags.push(tag);
                    // Update the last sequence
                    this.lastSequence = tag;
                }
            }
            else {
                this.tags.push(tag);
            }
        });
        this.tags.push(new RouteEndTag(this.route.data[this.route.data.length - 1]));
    }
    addToMap() {
        this.tags.forEach(t => {
            if (!t.visibleOnMap()) {
                return;
            }
            if (!this.layerGroups.has(t.type())) {
                this.layerGroups.set(t.type(), { visible: true, group: new LayerGroup() });
                this.layerGroups.get(t.type()).group.addTo(this.map);
            }
            t.addToMap(this.layerGroups.get(t.type()).group);
        });
    }
    flyToTag(tag) {
        if (this.focusedTag && this.focusedTag.type() === 'drive') {
            this.focusedTag.layer.removeFrom(this.map);
        }
        if (tag.type() === 'drive') {
            tag.addToMap(this.map);
        }
        else if (this.layerGroups.get(tag.type()).visible) {
            this.map.fitBounds(tag.getBounds(), {
                padding: [10, 10],
                maxZoom: 17,
            });
            tag.layer.openPopup();
        }
        this.focusedTag = tag;
    }
    reset() {
        this.tags = [];
        this.layerGroups.forEach(layer => layer.group.clearLayers());
        if (this.focusedTag) {
            this.focusedTag.layer.removeFrom(this.map);
        }
    }
}

class LocalLayer$1 {
    constructor(visible) {
        this.visible = visible;
    }
}
class RouteRenderer {
    constructor() {
        this.layers = new Map();
        this._loading = new Subject();
        this.loading$ = this._loading.asObservable();
    }
    render(map, route, routeParams) {
        this.map = map;
        this.route = route;
        this.routeParams = routeParams;
        this._loading.next(true);
        this.renderPathLayer();
        this.renderTimeline();
        this._loading.next(false);
    }
    renderPathLayer() {
        const l = new LocalLayer$1(true);
        // Build the route feature
        this.routePathFeature = {
            type: 'Feature',
            geometry: {
                type: 'LineString',
                coordinates: this.route.data.map(r => r.coords())
            },
            properties: {
                coordTimes: this.route.data.map(r => moment(r.tracker_time).format('YYYY-MM-DD HH:mm:ss'))
            }
        };
        // Construct the layer
        const geo = new GeoJSON(this.routePathFeature);
        geo.setStyle({
            color: '#ff0000',
            weight: 3,
            opacity: 1
        });
        l.group = geo;
        l.group.addTo(this.map);
        this.map.fitBounds(geo.getBounds(), {
            padding: [20, 20],
            animate: true,
        });
        this.layers.set('path', l);
    }
    renderSegmentsPathLayer(meta, options) {
        return multiOptionsPolyline(this.route.data.map(r => latLng(r.lat, r.lng, meta(r))), options);
    }
    renderTimeline() {
        this.routeTimeline = new RouteTimeline(this.map, this.route, this.routeParams);
        this.routeTimeline.addToMap();
    }
    reset() {
        this.layers.forEach((layer) => layer.group.remove());
        this.routeTimeline.reset();
        if (this.selectedPacketLayer) {
            this.selectedPacketLayer.layer.remove();
        }
    }
    flyToPacket(packet) {
        if (this.selectedPacketLayer) {
            this.selectedPacketLayer.layer.remove();
        }
        this.selectedPacketLayer = new RoutePacketTag(packet);
        this.selectedPacketLayer.addToMap(this.map);
        this.map.fitBounds(this.selectedPacketLayer.getBounds(), {
            padding: [10, 10],
            maxZoom: 17,
        });
        this.selectedPacketLayer.layer.openPopup();
    }
    export(filename) {
        return new Promise((resolve) => {
            leafletImage(this.map, (err, canvas) => {
                canvas.toBlob((blob) => {
                    saveAs(blob, filename + '.png');
                    resolve();
                });
            });
        });
    }
}

/**
 * A resource list contains data and meta
 */
class ModelsList {
}
class GroupedModelsList {
}
class Message {
}
class StoreService {
    constructor(http, config, errors) {
        this.http = http;
        this.config = config;
        this.errors = errors;
        this.customDataSubject = new Subject();
        this.customData$ = this.customDataSubject.asObservable();
        /**
         * Store options
         */
        this.storeOptions = {};
    }
    /**
     * Access the custom store
     */
    get store() {
        return this._store;
    }
    /**
     * Access the custom store
     */
    get dataSource() {
        return this._defaultDataSource;
    }
    /**
     * Convert dx load options to http parameters
     * @param options parameters
     */
    static loadOptionsToHttpParams(options) {
        function isNotEmpty(value) {
            return value !== undefined && value !== null && value !== '';
        }
        let params = new HttpParams();
        ['skip',
            'take',
            'requireTotalCount',
            'requireGroupCount',
            'sort',
            'filter',
            'totalSummary',
            'group',
            'searchExpr',
            'searchValue',
            'groupSummary'
        ].forEach((i) => {
            if (i in options && isNotEmpty(options[i]) && typeof options[i] !== 'function') {
                params = params.set(i, JSON.stringify(options[i]));
            }
        });
        [
            'searchOperation',
        ].forEach((i) => {
            if (i in options && isNotEmpty(options[i]) && typeof options[i] !== 'function') {
                params = params.set(i, options[i]);
            }
        });
        return params;
    }
    initStore(model) {
        this._store = new CustomStore({
            key: this.key(),
            load: (options) => {
                return this.load(StoreService.loadOptionsToHttpParams(options)).pipe(tap(l => {
                    if (l.hasOwnProperty('custom')) {
                        this.customDataSubject.next(l.custom);
                    }
                }), map(l => {
                    if (!options.group) {
                        l.data = l.data.map(m => new model(m));
                    }
                    else {
                        l.data.map(g => {
                            g.items = g.items.map(m => new model(m));
                        });
                    }
                    return l;
                }), catchError(err => {
                    this.errors.handle(err);
                    return throwError(err);
                })).toPromise();
            },
            errorHandler: (err) => {
                console.log('Error:', JSON.stringify(err));
            },
            byKey: (key) => {
                return this.get(key).pipe(catchError(err => {
                    this.errors.handle(err);
                    return throwError(err);
                })).toPromise();
            },
            update: (key, values) => this.update(key, values).pipe(catchError(err => {
                this.errors.handle(err);
                return throwError(err);
            })).toPromise(),
            insert: (values) => this.insert(values).pipe(catchError(err => {
                this.errors.handle(err);
                return throwError(err);
            })).toPromise(),
            remove: (key) => this.remove(key).pipe(catchError(err => {
                this.errors.handle(err);
                return throwError(err);
            })).toPromise(),
        });
    }
    /**
     * Create new dx data source
     */
    newDataSource(options, isDefault) {
        const all = options || {};
        all.store = this._store;
        if (isDefault) {
            return this._defaultDataSource = new DataSource(all);
        }
        return new DataSource(all);
    }
    /**
     * Create new dx data source
     */
    newGroupedDataSource(by, options, isDefault) {
        const all = options || {};
        all.store = this._store;
        all.postProcess = (data) => map$1(groupBy(data, by), (value, key) => {
            return { key, items: value };
        });
        if (isDefault) {
            return this._defaultDataSource = new DataSource(all);
        }
        return new DataSource(all);
    }
    newDetachedTreeDataSource(options, parentId = 'parent_id') {
        return __awaiter(this, void 0, void 0, function* () {
            const original = this.newDataSource();
            const all = options || {};
            all.store = new ArrayStore({
                key: this.key(),
                data: arrayToTree(yield original.load(), { dataField: null, parentId, childrenField: 'items' }),
            });
            // Data source
            return new DataSource(all);
        });
    }
    newDetachedDataSource(options) {
        const original = this.newDataSource();
        const all = options || {};
        all.store = new ArrayStore({
            key: 'id',
            data: [],
        });
        all.store.load = (loadOptions) => {
            return original.load();
        };
        // Data source
        return new DataSource(all);
    }
    /**
     * Resource id column
     */
    key() {
        return 'id';
    }
    /**
     * get resource
     * @param id the resource ID
     * @param values data
     */
    get(id) {
        return of({});
    }
}

class ConfigService {
    constructor(http) {
        this.http = http;
    }
    /**
     * Load configuration from a file
     */
    load(fileUrl) {
        return this.http.get(fileUrl)
            .toPromise()
            .then(data => {
            this._config = data;
            return this._config;
        });
    }
    get config() {
        return this._config;
    }
    get(name, def) {
        if (this._config.hasOwnProperty(name)) {
            return this._config[name];
        }
        return def;
    }
    apiUrl(...path) {
        return this.get('apiEndpoint', '') + path.join('/');
    }
    apiVerUrl(...path) {
        return this.get('apiEndpoint', '') + '/' + this.get('apiVersion', '') + path.join('/');
    }
}
ConfigService.ɵfac = function ConfigService_Factory(t) { return new (t || ConfigService)(ɵɵinject(HttpClient)); };
ConfigService.ɵprov = ɵɵdefineInjectable({ token: ConfigService, factory: ConfigService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ConfigService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }]; }, null); })();

class ConfigModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('ConfigModule is already loaded. Please add it in AppModule only.');
        }
    }
    static forRoot(options) {
        return {
            ngModule: ConfigModule,
            providers: [
                {
                    provide: CONFIG_MODULE_OPTIONS_TOKEN,
                    useValue: options
                },
                // Load configuration from the url and setup auth service api endpoint
                {
                    provide: APP_INITIALIZER,
                    multi: true,
                    deps: [CONFIG_MODULE_OPTIONS_TOKEN, ConfigService],
                    useFactory: configServiceProvider
                }
            ]
        };
    }
}
ConfigModule.ɵmod = ɵɵdefineNgModule({ type: ConfigModule });
ConfigModule.ɵinj = ɵɵdefineInjector({ factory: function ConfigModule_Factory(t) { return new (t || ConfigModule)(ɵɵinject(ConfigModule, 12)); }, providers: [ConfigService], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ConfigModule, { imports: [CommonModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ConfigModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                providers: [ConfigService],
                imports: [
                    CommonModule
                ],
            }]
    }], function () { return [{ type: ConfigModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();
// Config token
const CONFIG_MODULE_OPTIONS_TOKEN = new InjectionToken('forRoot() config configuration.');
// Config service provider
function configServiceProvider(options, configService) {
    const f = () => {
        return configService.load(options.url).then(() => {
            // Configure the auth module endpoint
            /*if (options.auth) {
              authService.apiEndpoint = configService.get('apiEndpoint', '');
            }*/
        });
    };
    return f;
}

// Config token
const AUTH_MODULE_OPTIONS_TOKEN = new InjectionToken('forRoot() auth configuration.');

class AuthService {
    constructor(options, httpClient, config, router) {
        this.options = options;
        this.httpClient = httpClient;
        this.config = config;
        this.router = router;
        this.jwtHelperService = new JwtHelperService();
        this.loginChanged = new EventEmitter();
    }
    login(email, password, rememberMe) {
        const body = new HttpParams()
            .set('email', email)
            .set('password', password)
            .set('remember_me', rememberMe.toString());
        const postObservable = this.httpClient.post(this.config.apiUrl(this.options.apiLoginUrl), body.toString(), {
            headers: AuthService.headers,
        });
        const subject = new ReplaySubject(1);
        subject.subscribe((r) => {
            this.setAccessToken(r.token);
            this.setRefreshToken(r.refresh_token);
            this.loginChanged.emit(true);
        }, (err) => {
            this.handleAuthenticationError(err);
        });
        postObservable.subscribe(subject);
        return subject;
    }
    refresh() {
        const body = new HttpParams()
            .set('refresh_token', this.getRefreshToken());
        const refreshObservable = this.httpClient.post(this.config.apiUrl(this.options.apiRefreshUrl), body.toString(), {
            headers: AuthService.headers,
        });
        const refreshSubject = new ReplaySubject(1);
        refreshSubject.subscribe((r) => {
            this.setAccessToken(r.token);
            this.setRefreshToken(r.refresh_token);
        }, (err) => {
            this.handleAuthenticationError(err);
        });
        refreshObservable.subscribe(refreshSubject);
        return refreshSubject;
    }
    recovery(email, baseUrl) {
        const body = new HttpParams()
            .set('email', email).set("source_base_url", baseUrl);
        return this.httpClient.post(this.config.apiUrl(this.options.apiRecoveryUrl), body.toString(), {
            headers: AuthService.headers,
        });
    }
    recoveryChangePassword(request) {
        return this.httpClient.post(this.config.apiUrl(this.options.apiRecoveryChangePasswordUrl), request);
    }
    accessTokenExpired() {
        const token = this.getAccessToken();
        if (!token) {
            return true;
        }
        return this.jwtHelperService.isTokenExpired(token);
    }
    refreshTokenExpired() {
        const token = this.getRefreshToken();
        if (!token) {
            return true;
        }
        return this.jwtHelperService.isTokenExpired(token);
    }
    logout() {
        this.setAccessToken(null);
        this.setRefreshToken(null);
        this.loginChanged.emit(false);
        this.toLogin();
    }
    isAuthenticated() {
        const token = this.getRefreshToken();
        if (token) {
            return !this.refreshTokenExpired();
        }
        return !this.accessTokenExpired();
    }
    toLogin() {
        this.router.navigateByUrl(this.options.clientLoginUrl);
        window.location.reload();
    }
    loginUrlTree() {
        return this.router.parseUrl(this.options.clientLoginUrl);
    }
    handleAuthenticationError(err) {
        // TODO: Only for authentication error codes
        this.setAccessToken(null);
        this.setRefreshToken(null);
    }
    setAccessToken(accessToken) {
        if (!accessToken) {
            localStorage.removeItem('access_token');
        }
        else {
            localStorage.setItem('access_token', accessToken);
        }
    }
    setRefreshToken(refreshToken) {
        if (!refreshToken) {
            localStorage.removeItem('refresh_token');
        }
        else {
            localStorage.setItem('refresh_token', refreshToken);
        }
    }
    getAccessToken() {
        return localStorage.getItem('access_token');
    }
    getRefreshToken() {
        return localStorage.getItem('refresh_token');
    }
}
AuthService.headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(ɵɵinject(AUTH_MODULE_OPTIONS_TOKEN), ɵɵinject(HttpClient), ɵɵinject(ConfigService), ɵɵinject(Router)); };
AuthService.ɵprov = ɵɵdefineInjectable({ token: AuthService, factory: AuthService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [AUTH_MODULE_OPTIONS_TOKEN]
            }] }, { type: HttpClient }, { type: ConfigService }, { type: Router }]; }, null); })();

class AuthGuard {
    constructor(authService) {
        this.authService = authService;
    }
    canActivate(next, state) {
        if (!this.authService.isAuthenticated()) {
            return this.authService.loginUrlTree();
        }
        return true;
    }
    canActivateChild(next, state) {
        if (!this.authService.isAuthenticated()) {
            return this.authService.loginUrlTree();
        }
        return true;
    }
}
AuthGuard.ɵfac = function AuthGuard_Factory(t) { return new (t || AuthGuard)(ɵɵinject(AuthService)); };
AuthGuard.ɵprov = ɵɵdefineInjectable({ token: AuthGuard, factory: AuthGuard.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthGuard, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: AuthService }]; }, null); })();

class JwtInterceptor {
    constructor(authService) {
        this.authService = authService;
    }
    intercept(request, next) {
        const token = this.authService.getAccessToken();
        let clone;
        if (token) {
            clone = request.clone({
                setHeaders: {
                    Accept: `application/json`,
                    Authorization: `Bearer ${token}`
                }
            });
        }
        else {
            clone = request.clone({
                setHeaders: {
                    Accept: `application/json`,
                }
            });
        }
        return next.handle(clone);
    }
}
JwtInterceptor.ɵfac = function JwtInterceptor_Factory(t) { return new (t || JwtInterceptor)(ɵɵinject(AuthService)); };
JwtInterceptor.ɵprov = ɵɵdefineInjectable({ token: JwtInterceptor, factory: JwtInterceptor.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(JwtInterceptor, [{
        type: Injectable
    }], function () { return [{ type: AuthService }]; }, null); })();

class JwtRefreshInterceptor {
    constructor(authService, jwtInterceptor) {
        this.authService = authService;
        this.jwtInterceptor = jwtInterceptor;
    }
    intercept(request, next) {
        return next.handle(request).pipe(catchError((err) => {
            if (this.authService.refreshTokenExpired()) {
                this.authService.toLogin();
                return throwError(err);
            }
            const errorResponse = err;
            if (errorResponse.status === 401 && errorResponse.error.message === 'invalid or expired jwt') {
                return this.authService.refresh().pipe(mergeMap(() => {
                    return this.jwtInterceptor.intercept(request, next);
                }));
            }
            return throwError(err);
        }));
    }
}
JwtRefreshInterceptor.ɵfac = function JwtRefreshInterceptor_Factory(t) { return new (t || JwtRefreshInterceptor)(ɵɵinject(AuthService), ɵɵinject(JwtInterceptor)); };
JwtRefreshInterceptor.ɵprov = ɵɵdefineInjectable({ token: JwtRefreshInterceptor, factory: JwtRefreshInterceptor.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(JwtRefreshInterceptor, [{
        type: Injectable
    }], function () { return [{ type: AuthService }, { type: JwtInterceptor }]; }, null); })();

class PasswordChangeRequest {
}
class ProfileService {
    constructor(options, httpClient, config) {
        this.options = options;
        this.httpClient = httpClient;
        this.config = config;
    }
    user() {
        return this.httpClient.get(this.config.apiUrl(this.options.apiMeUrl)).pipe(map(r => new User(r)));
    }
    update(values) {
        return this.httpClient.put(this.config.apiUrl(this.options.apiMeUrl), values);
    }
    changePassword(values) {
        return this.httpClient.post(this.config.apiUrl(`${this.options.apiMeUrl}/change-password`), values);
    }
}
ProfileService.ɵfac = function ProfileService_Factory(t) { return new (t || ProfileService)(ɵɵinject(AUTH_MODULE_OPTIONS_TOKEN), ɵɵinject(HttpClient), ɵɵinject(ConfigService)); };
ProfileService.ɵprov = ɵɵdefineInjectable({ token: ProfileService, factory: ProfileService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ProfileService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [AUTH_MODULE_OPTIONS_TOKEN]
            }] }, { type: HttpClient }, { type: ConfigService }]; }, null); })();

class ProfileResolver {
    constructor(service) {
        this.service = service;
    }
    resolve(route, state) {
        const supportImpersonate = route.data.supportImpersonate;
        return new Promise((resolve, reject) => {
            this.service.user().subscribe((user) => {
                if (!supportImpersonate && user.impersonated_by) {
                    resolve(user.impersonated_by);
                }
                else {
                    resolve(user);
                }
            }, (err) => reject(err));
        });
    }
}
ProfileResolver.ɵfac = function ProfileResolver_Factory(t) { return new (t || ProfileResolver)(ɵɵinject(ProfileService)); };
ProfileResolver.ɵprov = ɵɵdefineInjectable({ token: ProfileResolver, factory: ProfileResolver.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ProfileResolver, [{
        type: Injectable
    }], function () { return [{ type: ProfileService }]; }, null); })();

class ProfileModule {
}
ProfileModule.ɵmod = ɵɵdefineNgModule({ type: ProfileModule });
ProfileModule.ɵinj = ɵɵdefineInjector({ factory: function ProfileModule_Factory(t) { return new (t || ProfileModule)(); }, providers: [
        ProfileService,
        ProfileResolver,
    ], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ProfileModule, { imports: [CommonModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ProfileModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    CommonModule
                ],
                providers: [
                    ProfileService,
                    ProfileResolver,
                ]
            }]
    }], null, null); })();

class AuthModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('AuthModule is already loaded. Please add it in AppModule only.');
        }
    }
    static forRoot(options) {
        return {
            ngModule: AuthModule,
            providers: [
                {
                    provide: AUTH_MODULE_OPTIONS_TOKEN,
                    useValue: options
                },
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: JwtInterceptor,
                    multi: true
                },
                // Needed as dependency for the token refreshed
                JwtInterceptor,
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: JwtRefreshInterceptor,
                    multi: true
                }
            ]
        };
    }
}
AuthModule.ɵmod = ɵɵdefineNgModule({ type: AuthModule });
AuthModule.ɵinj = ɵɵdefineInjector({ factory: function AuthModule_Factory(t) { return new (t || AuthModule)(ɵɵinject(AuthModule, 12)); }, imports: [[
            CommonModule,
            ProfileModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(AuthModule, { imports: [CommonModule,
        ProfileModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    CommonModule,
                    ProfileModule,
                ],
            }]
    }], function () { return [{ type: AuthModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();

class ErrorsService {
    constructor() {
        this.alert = {
            visible: false,
            width: 550,
            height: 250,
            elementAttr: { class: 'alert-popup' },
            buttons: [
                {
                    widget: 'dxButton',
                    toolbar: 'bottom',
                    location: 'after',
                    options: {
                        text: 'Ok',
                        type: 'normal',
                        onClick: () => {
                            this.alert.visible = false;
                        }
                    }
                }
            ],
            title: null,
            content: null,
        };
    }
    handle(error) {
        var _a;
        if (error instanceof HttpErrorResponse) {
            // Server or connection error happened
            if (!navigator.onLine) {
                // Handle offline error
                this.showMessage('Pas de connexion Internet');
            }
            else {
                this.alert.width = 300;
                this.alert.height = 200;
                // Handle Http Error (error.status === 403, 404...)
                const message = ((_a = error.error) === null || _a === void 0 ? void 0 : _a.message) || error.message;
                this.showMessage(`<p class="text-base">${message}</p>`, 'Erreur');
            }
        }
        else {
            this.alert.width = 550;
            this.alert.height = 250;
            this.showMessage(`<pre>${error.message}</pre><pre>${error.stack}</pre>`, error.name);
        }
        console.log(error);
    }
    showMessage(message, title) {
        this.alert.title = title;
        this.alert.content = message;
        this.alert.visible = true;
    }
}
ErrorsService.ɵfac = function ErrorsService_Factory(t) { return new (t || ErrorsService)(); };
ErrorsService.ɵprov = ɵɵdefineInjectable({ token: ErrorsService, factory: ErrorsService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ErrorsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class GlobalErrorHandler {
    constructor(errors) {
        this.errors = errors;
    }
    handleError(error) {
        this.errors.handle(error);
    }
}
GlobalErrorHandler.ɵfac = function GlobalErrorHandler_Factory(t) { return new (t || GlobalErrorHandler)(ɵɵinject(ErrorsService)); };
GlobalErrorHandler.ɵprov = ɵɵdefineInjectable({ token: GlobalErrorHandler, factory: GlobalErrorHandler.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(GlobalErrorHandler, [{
        type: Injectable
    }], function () { return [{ type: ErrorsService }]; }, null); })();

function notify(message, type, displayTime) {
    dxNotify({ message, position: { my: 'center', at: 'top', of: window, offset: '0 110' } }, type || 'success', displayTime || 3000);
}

function kmlParser(plainText) {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(plainText, 'text/xml');
    if (xmlDoc.documentElement.nodeName !== 'kml') {
        return [];
    }
    const googlePolygons = [];
    for (const item of xmlDoc.getElementsByTagName('Placemark')) {
        const polygons = item.getElementsByTagName('Polygon');
        for (const polygon of polygons) {
            const coords = polygon.getElementsByTagName('coordinates')[0].childNodes[0].nodeValue.trim();
            const points = coords.split(/\s+/);
            const googlePolygonsPaths = [];
            for (const point of points) {
                const coord = point.split(',');
                googlePolygonsPaths.push([parseFloat(coord[1]), parseFloat(coord[0])]);
            }
            googlePolygons.push(googlePolygonsPaths);
        }
    }
    return googlePolygons;
}
function massKmlParser(plainText) {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(plainText, 'text/xml');
    if (xmlDoc.documentElement.nodeName !== 'kml') {
        return [];
    }
    const polygons = [];
    for (const item of xmlDoc.getElementsByTagName('Placemark')) {
        const polygon = item.getElementsByTagName('Polygon')[0];
        const description = item.getElementsByTagName('description')[0].innerHTML;
        const descParts = description.split(/\s+/);
        const coords = polygon.getElementsByTagName('coordinates')[0].childNodes[0].nodeValue.trim();
        const points = coords.split(/\s+/);
        const polygonCoords = [];
        for (const point of points) {
            const coord = point.split(',');
            polygonCoords.push([parseFloat(coord[1]), parseFloat(coord[0])]);
        }
        polygons.push({ name: descParts[5], polygon: [polygonCoords] });
    }
    return polygons;
}

const dateFilters = [
    { value: 0, label: 'Période Personnalisée' },
    { value: 1, label: 'Dernière heure' },
    { value: 2, label: 'Aujourd\'hui' },
    { value: 3, label: 'Hier' },
    { value: 4, label: 'Avant hier' },
    { value: 5, label: 'Il y a 3 jours' },
    { value: 6, label: 'Cette Semaine' },
    { value: 7, label: 'La Semaine Dernière' },
    { value: 8, label: 'Ce Mois' },
    { value: 9, label: 'Le Mois Dernier' },
];
const dateFilterToPeriod = (filterValue) => {
    let from;
    let to;
    let isToday;
    switch (filterValue) {
        case 1:
            from = moment().subtract(1, 'hours').toDate();
            to = moment().toDate();
            break;
        case 2:
            from = moment().startOf('day').toDate();
            to = moment().endOf('day').toDate();
            isToday = true;
            break;
        case 3:
            from = moment().subtract(1, 'days').startOf('day').toDate();
            to = moment().subtract(1, 'days').endOf('day').toDate();
            break;
        case 4:
            from = moment().subtract(2, 'days').startOf('day').toDate();
            to = moment().subtract(2, 'days').endOf('day').toDate();
            break;
        case 5:
            from = moment().subtract(3, 'days').startOf('day').toDate();
            to = moment().subtract(3, 'days').endOf('day').toDate();
            break;
        case 6:
            from = moment().startOf('week').toDate();
            to = moment().toDate();
            break;
        case 7:
            from = moment().subtract(1, 'weeks').startOf('week').toDate();
            to = moment().subtract(1, 'weeks').endOf('week').toDate();
            break;
        case 8:
            from = moment().startOf('month').toDate();
            to = moment().toDate();
            break;
        case 9:
            from = moment().subtract(1, 'months').startOf('month').toDate();
            to = moment().subtract(1, 'months').endOf('month').toDate();
            break;
    }
    return [from, to, isToday];
};

const mapSatelliteLayer = tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
    attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    maxZoom: 22,
    maxNativeZoom: 18,
});
const getMapSatelliteLayer = () => {
    return tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
        attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
        maxZoom: 22,
        maxNativeZoom: 18,
    });
};
const mapStreetLayer = tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {
    // detectRetina: true,
    maxZoom: 22,
    maxNativeZoom: 18,
    attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
});
const getMapStreetLayer = () => {
    return tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {
        // detectRetina: true,
        maxZoom: 22,
        maxNativeZoom: 18,
        attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
    });
};
const mapLayersControl = {
    baseLayers: {
        Streets: mapStreetLayer,
        Satellite: mapSatelliteLayer,
    },
    overlays: {}
};

class SharedService {
    constructor() { }
}
SharedService.ɵfac = function SharedService_Factory(t) { return new (t || SharedService)(); };
SharedService.ɵprov = ɵɵdefineInjectable({ token: SharedService, factory: SharedService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SharedService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class SharedComponent {
    constructor() { }
    ngOnInit() {
    }
}
SharedComponent.ɵfac = function SharedComponent_Factory(t) { return new (t || SharedComponent)(); };
SharedComponent.ɵcmp = ɵɵdefineComponent({ type: SharedComponent, selectors: [["lib-shared"]], decls: 2, vars: 0, template: function SharedComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "p");
        ɵɵtext(1, " shared works! ");
        ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SharedComponent, [{
        type: Component,
        args: [{
                selector: 'lib-shared',
                template: `
    <p>
      shared works!
    </p>
  `,
                styles: []
            }]
    }], function () { return []; }, null); })();

function RouteMarkerPopupComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelement(3, "div", 3);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const key_r1 = ctx.$implicit;
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵtextInterpolate(key_r1);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ctx_r0.props[key_r1], ɵɵsanitizeHtml);
} }
class RouteMarkerPopupComponent {
    constructor() {
    }
    ngOnInit() {
        this.keys = Object.keys(this.props);
    }
}
RouteMarkerPopupComponent.ɵfac = function RouteMarkerPopupComponent_Factory(t) { return new (t || RouteMarkerPopupComponent)(); };
RouteMarkerPopupComponent.ɵcmp = ɵɵdefineComponent({ type: RouteMarkerPopupComponent, selectors: [["lib-route-marker-popup"]], inputs: { props: "props" }, decls: 3, vars: 2, consts: [[3, "height"], [1, "details-list", "p-3"], [4, "ngFor", "ngForOf"], [3, "innerHTML"]], template: function RouteMarkerPopupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "dx-scroll-view", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵtemplate(2, RouteMarkerPopupComponent_ng_container_2_Template, 4, 2, "ng-container", 2);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("height", 250);
        ɵɵadvance(2);
        ɵɵproperty("ngForOf", ctx.keys);
    } }, directives: [DxScrollViewComponent, NgForOf], styles: ["[_nghost-%COMP%]{font:500 14px var(--font)}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RouteMarkerPopupComponent, [{
        type: Component,
        args: [{
                selector: 'lib-route-marker-popup',
                templateUrl: './route-marker-popup.component.html',
                styleUrls: ['./route-marker-popup.component.scss']
            }]
    }], function () { return []; }, { props: [{
            type: Input
        }] }); })();

class RouteMarkerPopupModule {
}
RouteMarkerPopupModule.ɵmod = ɵɵdefineNgModule({ type: RouteMarkerPopupModule });
RouteMarkerPopupModule.ɵinj = ɵɵdefineInjector({ factory: function RouteMarkerPopupModule_Factory(t) { return new (t || RouteMarkerPopupModule)(); }, imports: [[
            CommonModule,
            DxScrollViewModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(RouteMarkerPopupModule, { declarations: [RouteMarkerPopupComponent], imports: [CommonModule,
        DxScrollViewModule], exports: [RouteMarkerPopupComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(RouteMarkerPopupModule, [{
        type: NgModule,
        args: [{
                declarations: [RouteMarkerPopupComponent],
                imports: [
                    CommonModule,
                    DxScrollViewModule
                ],
                exports: [RouteMarkerPopupComponent]
            }]
    }], null, null); })();

class SharedModule {
    constructor(injector) {
        this.injector = injector;
        // Convert `MapFieldPopupComponent` to a custom element.
        const RouteMarkerPopupComponentElement = createCustomElement(RouteMarkerPopupComponent, { injector: this.injector });
        // Register the custom element with the browser.
        customElements.define('route-marker-popup', RouteMarkerPopupComponentElement);
    }
}
SharedModule.ɵmod = ɵɵdefineNgModule({ type: SharedModule });
SharedModule.ɵinj = ɵɵdefineInjector({ factory: function SharedModule_Factory(t) { return new (t || SharedModule)(ɵɵinject(Injector)); }, imports: [[
            RouteMarkerPopupModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(SharedModule, { declarations: [SharedComponent], imports: [RouteMarkerPopupModule], exports: [SharedComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(SharedModule, [{
        type: NgModule,
        args: [{
                declarations: [SharedComponent],
                imports: [
                    RouteMarkerPopupModule,
                ],
                exports: [SharedComponent]
            }]
    }], function () { return [{ type: Injector }]; }, null); })();

class FieldSvgComponent {
    constructor() {
        this.strokeWidth = 1;
    }
    ngOnInit() {
        if (!this.field.hasOwnProperty('id')) {
            return;
        }
        [this.path, this.viewBox] = this.field.svgPath(50, 50);
        this.style = {
            stroke: this.field.color,
            fill: this.field.color.padEnd(7, 'f') + '20',
            'stroke-width': this.strokeWidth
        };
    }
}
FieldSvgComponent.ɵfac = function FieldSvgComponent_Factory(t) { return new (t || FieldSvgComponent)(); };
FieldSvgComponent.ɵcmp = ɵɵdefineComponent({ type: FieldSvgComponent, selectors: [["lib-field-svg"]], inputs: { field: "field", width: "width", height: "height", strokeWidth: "strokeWidth" }, decls: 2, vars: 5, consts: [["xmlns", "http://www.w3.org/2000/svg", "x", "0", "y", "0"], ["vector-effect", "non-scaling-stroke", 3, "ngStyle"]], template: function FieldSvgComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵnamespaceSVG();
        ɵɵelementStart(0, "svg", 0);
        ɵɵelement(1, "polygon", 1);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵattribute("width", ctx.width)("height", ctx.height)("viewBox", ctx.viewBox);
        ɵɵadvance(1);
        ɵɵproperty("ngStyle", ctx.style);
        ɵɵattribute("points", ctx.path);
    } }, directives: [NgStyle], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FieldSvgComponent, [{
        type: Component,
        args: [{
                selector: 'lib-field-svg',
                templateUrl: './field-svg.component.html',
                styleUrls: ['./field-svg.component.css']
            }]
    }], function () { return []; }, { field: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }], strokeWidth: [{
            type: Input
        }] }); })();

class FieldSvgModule {
}
FieldSvgModule.ɵmod = ɵɵdefineNgModule({ type: FieldSvgModule });
FieldSvgModule.ɵinj = ɵɵdefineInjector({ factory: function FieldSvgModule_Factory(t) { return new (t || FieldSvgModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(FieldSvgModule, { declarations: [FieldSvgComponent], imports: [CommonModule], exports: [FieldSvgComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(FieldSvgModule, [{
        type: NgModule,
        args: [{
                declarations: [FieldSvgComponent],
                imports: [
                    CommonModule
                ],
                exports: [FieldSvgComponent]
            }]
    }], null, null); })();

const _c0 = ["kmlFilesBtn"];
function FieldDrawComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", 6);
    ɵɵlistener("leafletMapReady", function FieldDrawComponent_div_7_Template_div_leafletMapReady_1_listener($event) { ɵɵrestoreView(_r4); const ctx_r3 = ɵɵnextContext(); return ctx_r3.onMapReady($event); })("leafletDrawReady", function FieldDrawComponent_div_7_Template_div_leafletDrawReady_1_listener($event) { ɵɵrestoreView(_r4); const ctx_r5 = ɵɵnextContext(); return ctx_r5.onDrawReady($event); })("leafletDrawCreated", function FieldDrawComponent_div_7_Template_div_leafletDrawCreated_1_listener($event) { ɵɵrestoreView(_r4); const ctx_r6 = ɵɵnextContext(); return ctx_r6.onDrawCreated($event); })("leafletDrawEdited", function FieldDrawComponent_div_7_Template_div_leafletDrawEdited_1_listener($event) { ɵɵrestoreView(_r4); const ctx_r7 = ɵɵnextContext(); return ctx_r7.onDrawEdited($event); })("leafletDrawDeleted", function FieldDrawComponent_div_7_Template_div_leafletDrawDeleted_1_listener($event) { ɵɵrestoreView(_r4); const ctx_r8 = ɵɵnextContext(); return ctx_r8.onDrawDeleted($event); });
    ɵɵelement(2, "div", 7);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("leafletLayersControl", ctx_r1.layersControl)("leafletOptions", ctx_r1.options)("leafletDrawOptions", ctx_r1.drawOptions);
    ɵɵadvance(1);
    ɵɵproperty("leafletLayer", ctx_r1.drawnItems);
} }
const _c1 = function () { return { class: "polygon-editor" }; };
const _c2 = function (a1) { return { text: "Fichier KML", onClick: a1 }; };
const _c3 = function (a1) { return { text: "Sauvegarder", onClick: a1 }; };
const _c4 = function (a1) { return { text: "Annuler", onClick: a1 }; };
class FieldDrawComponent {
    constructor() {
        this.polygonChange = new EventEmitter();
        this.satelliteLayers = tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
            attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
            maxZoom: 22,
            maxNativeZoom: 18,
        });
        this.streetMaps = tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {
            // detectRetina: true,
            maxZoom: 22,
            maxNativeZoom: 18,
            attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
        });
        this.layersControl = {
            baseLayers: {
                Streets: this.streetMaps,
                Satellite: this.satelliteLayers,
            },
            overlays: {}
        };
        this.options = {
            layers: [this.satelliteLayers],
            zoom: 7,
            minZoom: 0,
            maxZoom: 22,
            maxNativeZoom: 18,
            center: [36.72, -4.43],
        };
        this.drawnItems = featureGroup();
        this.drawOptions = {
            position: 'topleft',
            draw: {
                // marker: false,
                polyline: false,
                circle: false,
                rectangle: false,
                circlemarker: false,
                polygon: {
                    drawError: {
                        color: '#24d200',
                        message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
                    },
                    shapeOptions: {
                        weight: 1,
                        color: '#1a8b00'
                    }
                },
            },
            edit: {
                featureGroup: this.drawnItems,
            }
        };
        this.cancel = this.cancel.bind(this);
        this.save = this.save.bind(this);
        this.uploadKML = this.uploadKML.bind(this);
    }
    onMapReady(map) {
        this.map = map;
    }
    onDrawCreated(e) {
        this.polygon = e.layer;
        this.drawnItems.clearLayers();
        this.drawnItems.addLayer(this.polygon);
    }
    onDrawEdited(e) {
        this.polygon = e.layers[0];
    }
    onDrawDeleted(e) {
        this.polygon = null;
    }
    onDrawReady(drawControl) {
        if (this.field && this.field.polygon) {
            this.addFieldPolygon();
        }
    }
    ngOnInit() {
    }
    addFieldPolygon() {
        this.polygon = this.originalPolygon = new Polygon(this.field.polygon.map(c => {
            return [c[1], c[0]];
        }), {
            fillColor: this.field.color,
            weight: 1,
        });
        this.polygon.bindTooltip(this.field.name, {
            direction: 'center',
            opacity: 0.6,
        });
        this.drawnItems.addLayer(this.polygon);
        this.map.fitBounds(this.polygon.getBounds(), {
            padding: [50, 50],
            maxZoom: 21,
        });
    }
    save() {
        if (this.polygon) {
            this.polygonChange.emit(this.polygon.getLatLngs()[0].map(ll => [ll.lng, ll.lat]));
        }
        else {
            this.polygonChange.emit(null);
        }
        this.visible = false;
    }
    cancel() {
        this.drawnItems.clearLayers();
        if (this.originalPolygon) {
            this.drawnItems.addLayer(this.originalPolygon);
            this.map.fitBounds(this.originalPolygon.getBounds(), {
                padding: [50, 50],
                maxZoom: 21,
            });
        }
        this.visible = false;
    }
    onKmlUpload(e) {
        const file = e.target.files[0];
        const reader = new FileReader(); // FileReader instance
        reader.addEventListener('load', () => {
            this.polygon = new Polygon(kmlParser(reader.result));
            this.drawnItems.clearLayers();
            this.drawnItems.addLayer(this.polygon);
            this.map.fitBounds(this.polygon.getBounds(), {
                padding: [50, 50],
                maxZoom: 21,
            });
        });
        reader.readAsText(file);
    }
    uploadKML() {
        this.kmlFilesBtn.nativeElement.click();
    }
}
FieldDrawComponent.ɵfac = function FieldDrawComponent_Factory(t) { return new (t || FieldDrawComponent)(); };
FieldDrawComponent.ɵcmp = ɵɵdefineComponent({ type: FieldDrawComponent, selectors: [["lib-field-draw"]], viewQuery: function FieldDrawComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.kmlFilesBtn = _t.first);
    } }, inputs: { field: "field" }, outputs: { polygonChange: "polygonChange" }, decls: 8, vars: 18, consts: [["icon", "image", "type", "default", "stylingMode", "outlined", "text", "Dessiner", 1, "polygon-draw-btn", 3, "onClick"], ["id", "kmlFiles", "type", "file", "accept", ".kml", 1, "hidden", 3, "change"], ["kmlFilesBtn", ""], ["title", "Editeur de parcelles", 1, "map-popup", 3, "width", "height", "showTitle", "dragEnabled", "closeOnOutsideClick", "elementAttr", "visible", "visibleChange"], ["widget", "dxButton", "toolbar", "bottom", "location", "after", 3, "options"], [4, "dxTemplate", "dxTemplateOf"], ["id", "draw-map", "leaflet", "", "leafletDraw", "", 1, "draw-map", 3, "leafletLayersControl", "leafletOptions", "leafletDrawOptions", "leafletMapReady", "leafletDrawReady", "leafletDrawCreated", "leafletDrawEdited", "leafletDrawDeleted"], [3, "leafletLayer"]], template: function FieldDrawComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "dx-button", 0);
        ɵɵlistener("onClick", function FieldDrawComponent_Template_dx_button_onClick_0_listener() { return ctx.visible = true; });
        ɵɵelementEnd();
        ɵɵelementStart(1, "input", 1, 2);
        ɵɵlistener("change", function FieldDrawComponent_Template_input_change_1_listener($event) { return ctx.onKmlUpload($event); });
        ɵɵelementEnd();
        ɵɵelementStart(3, "dx-popup", 3);
        ɵɵlistener("visibleChange", function FieldDrawComponent_Template_dx_popup_visibleChange_3_listener($event) { return ctx.visible = $event; });
        ɵɵelement(4, "dxi-toolbar-item", 4);
        ɵɵelement(5, "dxi-toolbar-item", 4);
        ɵɵelement(6, "dxi-toolbar-item", 4);
        ɵɵtemplate(7, FieldDrawComponent_div_7_Template, 3, 4, "div", 5);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(3);
        ɵɵproperty("width", 750)("height", 600)("showTitle", true)("dragEnabled", false)("closeOnOutsideClick", false)("elementAttr", ɵɵpureFunction0(11, _c1))("visible", ctx.visible);
        ɵɵadvance(1);
        ɵɵproperty("options", ɵɵpureFunction1(12, _c2, ctx.uploadKML));
        ɵɵadvance(1);
        ɵɵproperty("options", ɵɵpureFunction1(14, _c3, ctx.save));
        ɵɵadvance(1);
        ɵɵproperty("options", ɵɵpureFunction1(16, _c4, ctx.cancel));
        ɵɵadvance(1);
        ɵɵproperty("dxTemplateOf", "content");
    } }, directives: [DxButtonComponent, DxPopupComponent, DxiToolbarItemComponent, DxTemplateDirective, LeafletDirective, LeafletDrawDirective, LeafletLayersControlDirective, LeafletLayerDirective], styles: [".draw-map[_ngcontent-%COMP%]{height:499px;padding:0;width:750px}  .polygon-draw-btn{height:36px}  .polygon-draw-btn .dx-icon{background-position:0 0;background-size:20px 20px!important;font-size:20px!important;height:22px!important;line-height:20px!important;margin-left:0;margin-right:8px;padding:0;text-align:center;width:22px!important}  .map-popup.dx-state-invisible{display:block!important;visibility:hidden!important}  .map-popup .dx-popup-content{overflow:hidden;padding:0}  .map-popup .dx-popup-normal.dx-state-invisible{display:block!important;visibility:hidden!important}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FieldDrawComponent, [{
        type: Component,
        args: [{
                selector: 'lib-field-draw',
                templateUrl: './field-draw.component.html',
                styleUrls: ['./field-draw.component.scss']
            }]
    }], function () { return []; }, { field: [{
            type: Input
        }], polygonChange: [{
            type: Output
        }], kmlFilesBtn: [{
            type: ViewChild,
            args: ['kmlFilesBtn']
        }] }); })();

class FieldDrawModule {
}
FieldDrawModule.ɵmod = ɵɵdefineNgModule({ type: FieldDrawModule });
FieldDrawModule.ɵinj = ɵɵdefineInjector({ factory: function FieldDrawModule_Factory(t) { return new (t || FieldDrawModule)(); }, imports: [[
            CommonModule,
            DxPopupModule,
            LeafletModule,
            LeafletDrawModule,
            DxButtonModule,
            DxFileUploaderModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(FieldDrawModule, { declarations: [FieldDrawComponent], imports: [CommonModule,
        DxPopupModule,
        LeafletModule,
        LeafletDrawModule,
        DxButtonModule,
        DxFileUploaderModule], exports: [FieldDrawComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(FieldDrawModule, [{
        type: NgModule,
        args: [{
                declarations: [FieldDrawComponent],
                imports: [
                    CommonModule,
                    DxPopupModule,
                    LeafletModule,
                    LeafletDrawModule,
                    DxButtonModule,
                    DxFileUploaderModule
                ],
                exports: [FieldDrawComponent]
            }]
    }], null, null); })();

const _c0$1 = ["csvUploadBtn"];
function LevelCalibrationComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "dx-data-grid", 6);
    ɵɵlistener("onToolbarPreparing", function LevelCalibrationComponent_div_2_Template_dx_data_grid_onToolbarPreparing_1_listener($event) { ɵɵrestoreView(_r4); const ctx_r3 = ɵɵnextContext(); return ctx_r3.onToolbarPreparing($event); })("onRowValidating", function LevelCalibrationComponent_div_2_Template_dx_data_grid_onRowValidating_1_listener($event) { ɵɵrestoreView(_r4); const ctx_r5 = ɵɵnextContext(); return ctx_r5.onRowValidating($event); });
    ɵɵelement(2, "dxo-editing", 7);
    ɵɵelementStart(3, "dxi-column", 8);
    ɵɵelement(4, "dxi-validation-rule", 9);
    ɵɵelementEnd();
    ɵɵelementStart(5, "dxi-column", 10);
    ɵɵelement(6, "dxi-validation-rule", 9);
    ɵɵelementEnd();
    ɵɵelement(7, "dxo-export", 11);
    ɵɵelement(8, "dxo-paging", 12);
    ɵɵelement(9, "dxo-filter-row", 13);
    ɵɵelementEnd();
    ɵɵelementStart(10, "dx-load-panel", 14);
    ɵɵlistener("visibleChange", function LevelCalibrationComponent_div_2_Template_dx_load_panel_visibleChange_10_listener($event) { ɵɵrestoreView(_r4); const ctx_r6 = ɵɵnextContext(); return ctx_r6.loadingVisible = $event; });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("dataSource", ctx_r0.ds)("showBorders", false)("showRowLines", true)("height", 450)("columnAutoWidth", true);
    ɵɵadvance(1);
    ɵɵproperty("allowDeleting", true)("allowAdding", true)("allowUpdating", true);
    ɵɵadvance(5);
    ɵɵproperty("enabled", true);
    ɵɵadvance(1);
    ɵɵproperty("pageSize", 100000);
    ɵɵadvance(1);
    ɵɵproperty("visible", true);
    ɵɵadvance(1);
    ɵɵproperty("visible", ctx_r0.loadingVisible)("showIndicator", true)("showPane", true)("shading", true)("closeOnOutsideClick", false);
} }
const _c1$1 = function (a3) { return { text: "Vider", icon: "trash", type: "default", onClick: a3 }; };
const _c2$1 = function (a3) { return { text: "Excel", icon: "upload", type: "default", onClick: a3 }; };
const _c3$1 = function (a3) { return { text: "Sauvegarder", icon: "save", type: "default", onClick: a3 }; };
class LevelCalibrationComponent {
    constructor() {
        this.ds = [];
        this.value = {};
        this.valueChange = new EventEmitter();
    }
    ngOnInit() {
        this.save = this.save.bind(this);
        this.clear = this.clear.bind(this);
        this.csv = this.csv.bind(this);
        this.addPoint = this.addPoint.bind(this);
        this.onToolbarPreparing = this.onToolbarPreparing.bind(this);
        this.onRowValidating = this.onRowValidating.bind(this);
        this.value = this.value || {};
        this.ds = Object.keys(this.value).map((x) => {
            return { x, y: this.value[x] };
        });
    }
    onToolbarPreparing(e) {
        this.grid = e.component;
        // e.toolbarOptions.visible = false;
    }
    save(e) {
        return __awaiter(this, void 0, void 0, function* () {
            this.hasErrors = false;
            if (!this.grid) {
                return;
            }
            yield this.grid.saveEditData();
            if (this.hasErrors) {
                return;
            }
            if (this.ds.length < 2) {
                notify('Il faut au moins deux points.');
                return;
            }
            this.value = {};
            this.ds.forEach(({ x, y }) => {
                this.value[x.toString()] = y;
            });
            this.popupVisible = false;
            this.valueChange.emit(this.value);
        });
    }
    addPoint() {
        this.grid.addRow();
    }
    onRowValidating(e) {
        this.hasErrors = this.hasErrors || !e.isValid;
    }
    csv(e) {
        this.csvUploadBtn.nativeElement.click();
    }
    clear(e) {
        this.ds.length = 0;
    }
    onCsvFileUpload(e) {
        this.loadingVisible = true;
        const file = e.target.files[0];
        const workbook = new Workbook();
        const reader = new FileReader();
        reader.onload = (event) => __awaiter(this, void 0, void 0, function* () {
            const buffer = reader.result;
            const worksheet = yield workbook.xlsx.load(buffer);
            worksheet.getWorksheet(1).eachRow(row => {
                const el = { x: '0', y: 0 };
                row.eachCell((cell, nb) => {
                    if (nb === 1) {
                        el.x = cell.value;
                    }
                    else if (nb === 2) {
                        el.y = cell.value;
                    }
                    this.ds.push(el);
                });
            });
            this.loadingVisible = false;
            this.csvUploadBtn.nativeElement.value = '';
        });
        reader.readAsArrayBuffer(file);
    }
}
LevelCalibrationComponent.ɵfac = function LevelCalibrationComponent_Factory(t) { return new (t || LevelCalibrationComponent)(); };
LevelCalibrationComponent.ɵcmp = ɵɵdefineComponent({ type: LevelCalibrationComponent, selectors: [["lib-level-calibration"]], viewQuery: function LevelCalibrationComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$1, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.csvUploadBtn = _t.first);
    } }, inputs: { value: "value" }, outputs: { valueChange: "valueChange" }, decls: 8, vars: 15, consts: [["stylingMode", "outlined", "type", "default", 3, "text", "onClick"], ["title", "Calibration", 1, "calibration-popup", 3, "width", "showTitle", "dragEnabled", "visible", "visibleChange"], [4, "dxTemplate", "dxTemplateOf"], ["widget", "dxButton", "location", "after", "toolbar", "bottom", 3, "options"], ["type", "file", "accept", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 1, "hidden", 3, "change"], ["csvUploadBtn", ""], [3, "dataSource", "showBorders", "showRowLines", "height", "columnAutoWidth", "onToolbarPreparing", "onRowValidating"], ["mode", "batch", 3, "allowDeleting", "allowAdding", "allowUpdating"], ["caption", "X (mm)", "dataField", "x", "dataType", "number"], ["type", "required"], ["caption", "Y (L)", "dataField", "y", "dataType", "number"], ["fileName", "calibartion", 3, "enabled"], [3, "pageSize"], [3, "visible"], ["shadingColor", "rgba(0,0,0,0.4)", 3, "visible", "showIndicator", "showPane", "shading", "closeOnOutsideClick", "visibleChange"]], template: function LevelCalibrationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "dx-button", 0);
        ɵɵlistener("onClick", function LevelCalibrationComponent_Template_dx_button_onClick_0_listener() { return ctx.popupVisible = true; });
        ɵɵelementEnd();
        ɵɵelementStart(1, "dx-popup", 1);
        ɵɵlistener("visibleChange", function LevelCalibrationComponent_Template_dx_popup_visibleChange_1_listener($event) { return ctx.popupVisible = $event; });
        ɵɵtemplate(2, LevelCalibrationComponent_div_2_Template, 11, 16, "div", 2);
        ɵɵelement(3, "dxi-toolbar-item", 3);
        ɵɵelement(4, "dxi-toolbar-item", 3);
        ɵɵelement(5, "dxi-toolbar-item", 3);
        ɵɵelementEnd();
        ɵɵelementStart(6, "input", 4, 5);
        ɵɵlistener("change", function LevelCalibrationComponent_Template_input_change_6_listener($event) { return ctx.onCsvFileUpload($event); });
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("text", "Calibration (" + ctx.ds.length + ")");
        ɵɵadvance(1);
        ɵɵproperty("width", 520)("showTitle", true)("dragEnabled", true)("visible", ctx.popupVisible);
        ɵɵadvance(1);
        ɵɵproperty("dxTemplateOf", "content");
        ɵɵadvance(1);
        ɵɵproperty("options", ɵɵpureFunction1(9, _c1$1, ctx.clear));
        ɵɵadvance(1);
        ɵɵproperty("options", ɵɵpureFunction1(11, _c2$1, ctx.csv));
        ɵɵadvance(1);
        ɵɵproperty("options", ɵɵpureFunction1(13, _c3$1, ctx.save));
    } }, directives: [DxButtonComponent, DxPopupComponent, DxTemplateDirective, DxiToolbarItemComponent, DxDataGridComponent, DxoEditingComponent, DxiColumnComponent, DxiValidationRuleComponent, DxoExportComponent, DxoPagingComponent, DxoFilterRowComponent, DxLoadPanelComponent], styles: [".calibration-popup .dx-popup-content{padding:0!important}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LevelCalibrationComponent, [{
        type: Component,
        args: [{
                selector: 'lib-level-calibration',
                templateUrl: './level-calibration.component.html',
                styleUrls: ['./level-calibration.component.scss']
            }]
    }], function () { return []; }, { csvUploadBtn: [{
            type: ViewChild,
            args: ['csvUploadBtn']
        }], value: [{
            type: Input
        }], valueChange: [{
            type: Output
        }] }); })();

class LevelCalibrationModule {
}
LevelCalibrationModule.ɵmod = ɵɵdefineNgModule({ type: LevelCalibrationModule });
LevelCalibrationModule.ɵinj = ɵɵdefineInjector({ factory: function LevelCalibrationModule_Factory(t) { return new (t || LevelCalibrationModule)(); }, imports: [[
            CommonModule,
            DxPopupModule,
            DxDataGridModule,
            DxButtonModule,
            DxLoadPanelModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(LevelCalibrationModule, { declarations: [LevelCalibrationComponent], imports: [CommonModule,
        DxPopupModule,
        DxDataGridModule,
        DxButtonModule,
        DxLoadPanelModule], exports: [LevelCalibrationComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(LevelCalibrationModule, [{
        type: NgModule,
        args: [{
                declarations: [LevelCalibrationComponent],
                imports: [
                    CommonModule,
                    DxPopupModule,
                    DxDataGridModule,
                    DxButtonModule,
                    DxLoadPanelModule
                ],
                exports: [LevelCalibrationComponent]
            }]
    }], null, null); })();

class PulseDotComponent {
    constructor() {
        this.color = 'green';
    }
    ngOnInit() {
    }
}
PulseDotComponent.ɵfac = function PulseDotComponent_Factory(t) { return new (t || PulseDotComponent)(); };
PulseDotComponent.ɵcmp = ɵɵdefineComponent({ type: PulseDotComponent, selectors: [["lib-pulse-dot"]], inputs: { color: "color", hint: "hint" }, decls: 1, vars: 4, template: function PulseDotComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "a");
    } if (rf & 2) {
        ɵɵclassMapInterpolate1("pulse-button ", ctx.color, "");
        ɵɵattribute("title", ctx.hint);
    } }, styles: [".pulse-button[_ngcontent-%COMP%]{-webkit-animation:pulse 1.25s cubic-bezier(.66,0,0,1) infinite;animation:pulse 1.25s cubic-bezier(.66,0,0,1) infinite;background-color:#e53e3e;background-repeat:no-repeat;background-size:cover;border:none;border-radius:50%;box-shadow:0 0 0 0 rgba(229,62,62,.7);color:rgba(229,62,62,0);cursor:pointer;display:inline-block;height:16px;position:relative;width:16px}.pulse-button.green[_ngcontent-%COMP%]{background-color:#54dc20;box-shadow:0 0 0 0 rgba(84,220,32,.7);color:rgba(84,220,32,0)}.pulse-button.orange[_ngcontent-%COMP%]{background-color:#ed8936;box-shadow:0 0 0 0 rgba(237,137,54,.7);color:rgba(237,137,54,0)}.pulse-button[_ngcontent-%COMP%]:hover{-webkit-animation:none;animation:none}@-webkit-keyframes pulse{to{box-shadow:0 0 0}}@keyframes pulse{to{box-shadow:0 0 0 20px}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PulseDotComponent, [{
        type: Component,
        args: [{
                selector: 'lib-pulse-dot',
                templateUrl: './pulse-dot.component.html',
                styleUrls: ['./pulse-dot.component.scss']
            }]
    }], function () { return []; }, { color: [{
            type: Input
        }], hint: [{
            type: Input
        }] }); })();

class PulseDotModule {
}
PulseDotModule.ɵmod = ɵɵdefineNgModule({ type: PulseDotModule });
PulseDotModule.ɵinj = ɵɵdefineInjector({ factory: function PulseDotModule_Factory(t) { return new (t || PulseDotModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(PulseDotModule, { declarations: [PulseDotComponent], imports: [CommonModule], exports: [PulseDotComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(PulseDotModule, [{
        type: NgModule,
        args: [{
                declarations: [PulseDotComponent],
                imports: [
                    CommonModule
                ],
                exports: [PulseDotComponent]
            }]
    }], null, null); })();

function FuelParamsEditorComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "dx-data-grid", 5);
    ɵɵlistener("onToolbarPreparing", function FuelParamsEditorComponent_div_3_Template_dx_data_grid_onToolbarPreparing_1_listener($event) { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(); return ctx_r2.onToolbarPreparing($event); });
    ɵɵelement(2, "dxo-editing", 6);
    ɵɵelement(3, "dxi-column", 7);
    ɵɵelement(4, "dxi-column", 8);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("dataSource", ctx_r0.params.calibration)("showBorders", false)("showRowLines", true)("columnAutoWidth", true);
    ɵɵadvance(1);
    ɵɵproperty("allowDeleting", true)("allowAdding", true)("allowUpdating", true);
} }
const _c0$2 = function () { return ["ADC3", "ADC5"]; };
const _c1$2 = function (a3) { return { text: "Sauvegarder", icon: "save", type: "default", onClick: a3 }; };
const _c2$2 = function (a3) { return { text: "Ajouter", icon: "plus", type: "default", onClick: a3 }; };
class FuelParamsEditorComponent {
    constructor() {
        this.paramsChange = new EventEmitter();
        this.calibrateBtn = {
            stylingMode: 'outlined',
            type: 'default',
            text: 'Calibration',
            onClick: () => {
                this.popupVisible = true;
            }
        };
        this.save = this.save.bind(this);
        this.addPoint = this.addPoint.bind(this);
        this.onToolbarPreparing = this.onToolbarPreparing.bind(this);
    }
    ngOnInit() {
        var _a;
        const hasParams = !!((_a = this.params) === null || _a === void 0 ? void 0 : _a.name);
        if (!hasParams) {
            this.params = new TrackerSettings({});
        }
    }
    onToolbarPreparing(e) {
        this.grid = e.component;
        e.toolbarOptions.visible = false;
    }
    save(e) {
        if (this.grid) {
            this.grid.saveEditData();
        }
        this.paramsChange.emit(this.params);
        this.popupVisible = false;
    }
    addPoint() {
        this.grid.addRow();
    }
}
FuelParamsEditorComponent.ɵfac = function FuelParamsEditorComponent_Factory(t) { return new (t || FuelParamsEditorComponent)(); };
FuelParamsEditorComponent.ɵcmp = ɵɵdefineComponent({ type: FuelParamsEditorComponent, selectors: [["lib-fuel-params-editor"]], inputs: { params: "params" }, outputs: { paramsChange: "paramsChange" }, decls: 6, vars: 16, consts: [[3, "items", "value", "valueChange", "onValueChanged"], ["name", "calibrate", "location", "after", 3, "options"], ["title", "Calibration Gauge Carburant", 1, "calibration-popup", 3, "width", "height", "showTitle", "dragEnabled", "visible", "visibleChange"], [4, "dxTemplate", "dxTemplateOf"], ["widget", "dxButton", "location", "after", "toolbar", "bottom", 3, "options"], [3, "dataSource", "showBorders", "showRowLines", "columnAutoWidth", "onToolbarPreparing"], ["mode", "batch", 3, "allowDeleting", "allowAdding", "allowUpdating"], ["dataField", "x", "dataType", "number"], ["dataField", "y", "dataType", "number"]], template: function FuelParamsEditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "dx-select-box", 0);
        ɵɵlistener("valueChange", function FuelParamsEditorComponent_Template_dx_select_box_valueChange_0_listener($event) { return ctx.params.name = $event; })("onValueChanged", function FuelParamsEditorComponent_Template_dx_select_box_onValueChanged_0_listener($event) { return ctx.save($event); });
        ɵɵelement(1, "dxi-button", 1);
        ɵɵelementEnd();
        ɵɵelementStart(2, "dx-popup", 2);
        ɵɵlistener("visibleChange", function FuelParamsEditorComponent_Template_dx_popup_visibleChange_2_listener($event) { return ctx.popupVisible = $event; });
        ɵɵtemplate(3, FuelParamsEditorComponent_div_3_Template, 5, 7, "div", 3);
        ɵɵelement(4, "dxi-toolbar-item", 4);
        ɵɵelement(5, "dxi-toolbar-item", 4);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("items", ɵɵpureFunction0(11, _c0$2))("value", ctx.params.name);
        ɵɵadvance(1);
        ɵɵproperty("options", ctx.calibrateBtn);
        ɵɵadvance(1);
        ɵɵproperty("width", 350)("height", 450)("showTitle", true)("dragEnabled", true)("visible", ctx.popupVisible);
        ɵɵadvance(1);
        ɵɵproperty("dxTemplateOf", "content");
        ɵɵadvance(1);
        ɵɵproperty("options", ɵɵpureFunction1(12, _c1$2, ctx.save));
        ɵɵadvance(1);
        ɵɵproperty("options", ɵɵpureFunction1(14, _c2$2, ctx.addPoint));
    } }, directives: [DxSelectBoxComponent, DxiButtonComponent, DxPopupComponent, DxTemplateDirective, DxiToolbarItemComponent, DxDataGridComponent, DxoEditingComponent, DxiColumnComponent], styles: [".calibration-popup .dx-popup-content{padding:0!important}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FuelParamsEditorComponent, [{
        type: Component,
        args: [{
                selector: 'lib-fuel-params-editor',
                templateUrl: './fuel-params-editor.component.html',
                styleUrls: ['./fuel-params-editor.component.scss']
            }]
    }], function () { return []; }, { params: [{
            type: Input
        }], paramsChange: [{
            type: Output
        }] }); })();

class FuelParamsEditorModule {
}
FuelParamsEditorModule.ɵmod = ɵɵdefineNgModule({ type: FuelParamsEditorModule });
FuelParamsEditorModule.ɵinj = ɵɵdefineInjector({ factory: function FuelParamsEditorModule_Factory(t) { return new (t || FuelParamsEditorModule)(); }, imports: [[
            CommonModule,
            DxSelectBoxModule,
            DxPopupModule,
            DxDataGridModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(FuelParamsEditorModule, { declarations: [FuelParamsEditorComponent], imports: [CommonModule,
        DxSelectBoxModule,
        DxPopupModule,
        DxDataGridModule], exports: [FuelParamsEditorComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(FuelParamsEditorModule, [{
        type: NgModule,
        args: [{
                declarations: [FuelParamsEditorComponent],
                imports: [
                    CommonModule,
                    DxSelectBoxModule,
                    DxPopupModule,
                    DxDataGridModule
                ],
                exports: [FuelParamsEditorComponent]
            }]
    }], null, null); })();

function TrackerChooserComponent_dx_select_box_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "dx-select-box", 2);
    ɵɵlistener("valueChange", function TrackerChooserComponent_dx_select_box_0_Template_dx_select_box_valueChange_0_listener($event) { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(); return ctx_r2.trackerId = $event; })("onValueChanged", function TrackerChooserComponent_dx_select_box_0_Template_dx_select_box_onValueChanged_0_listener($event) { ɵɵrestoreView(_r3); const ctx_r4 = ɵɵnextContext(); return ctx_r4.save($event); });
    ɵɵelement(1, "dxi-button", 3);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("items", ctx_r0.availableTrackers)("value", ctx_r0.trackerId)("searchEnabled", true);
    ɵɵadvance(1);
    ɵɵproperty("options", ctx_r0.refreshBtn);
} }
function TrackerChooserComponent_dx_text_box_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "dx-text-box", 4);
    ɵɵelement(1, "dxi-button", 5);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵproperty("readOnly", true)("value", ctx_r1.tracker.imei);
    ɵɵadvance(1);
    ɵɵproperty("options", ctx_r1.detachBtn);
} }
class TrackerChooserComponent {
    constructor() {
        this.valueChange = new EventEmitter();
        this.reload = new EventEmitter();
        this.refreshBtn = {
            type: 'default',
            icon: 'refresh',
            onClick: () => {
                this.refreshTrackers();
            }
        };
    }
    ngOnInit() {
        this.detachBtn = {
            type: 'default',
            icon: 'close',
            text: 'Détacher',
            hint: 'Détacher le traceur',
            visible: this.canAssign,
            disabled: false,
            onClick: () => {
                this.delete();
            }
        };
    }
    refreshTrackers() {
        this.reload.emit();
    }
    save(e) {
        this.valueChange.emit(this.trackerId);
        if (this.trackerId) {
            this.tracker = this.availableTrackers.find(t => t.id === this.trackerId);
        }
    }
    delete() {
        const result = confirm('Voulez-vous vraiment détacher ce traceur', 'Confirmation');
        result.then((confirmed) => {
            if (confirmed) {
                this.trackerId = 0;
                this.save(0);
            }
        });
    }
}
TrackerChooserComponent.ɵfac = function TrackerChooserComponent_Factory(t) { return new (t || TrackerChooserComponent)(); };
TrackerChooserComponent.ɵcmp = ɵɵdefineComponent({ type: TrackerChooserComponent, selectors: [["lib-tracker-chooser"]], inputs: { canAssign: "canAssign", trackerId: "trackerId", tracker: "tracker", availableTrackers: "availableTrackers" }, outputs: { valueChange: "valueChange", reload: "reload" }, decls: 2, vars: 2, consts: [["displayExpr", "imei", "valueExpr", "id", "placeholder", "S\u00E9lection...", "noDataText", "Aucun tracker disponible", 3, "items", "value", "searchEnabled", "valueChange", "onValueChanged", 4, "ngIf"], [3, "readOnly", "value", 4, "ngIf"], ["displayExpr", "imei", "valueExpr", "id", "placeholder", "S\u00E9lection...", "noDataText", "Aucun tracker disponible", 3, "items", "value", "searchEnabled", "valueChange", "onValueChanged"], ["name", "refresh-trackers", "location", "after", 3, "options"], [3, "readOnly", "value"], ["name", "detach-btn", "location", "after", 3, "options"]], template: function TrackerChooserComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, TrackerChooserComponent_dx_select_box_0_Template, 2, 4, "dx-select-box", 0);
        ɵɵtemplate(1, TrackerChooserComponent_dx_text_box_1_Template, 2, 3, "dx-text-box", 1);
    } if (rf & 2) {
        ɵɵproperty("ngIf", !ctx.trackerId && ctx.canAssign);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.trackerId);
    } }, directives: [NgIf, DxSelectBoxComponent, DxiButtonComponent, DxTextBoxComponent], styles: [".imei[_ngcontent-%COMP%]{background-color:#e7e7e7;border-radius:8px;font-size:14px;font-weight:400;padding:5px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TrackerChooserComponent, [{
        type: Component,
        args: [{
                selector: 'lib-tracker-chooser',
                templateUrl: './tracker-chooser.component.html',
                styleUrls: ['./tracker-chooser.component.scss']
            }]
    }], function () { return []; }, { canAssign: [{
            type: Input
        }], trackerId: [{
            type: Input
        }], tracker: [{
            type: Input
        }], availableTrackers: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], reload: [{
            type: Output
        }] }); })();

class TrackerChooserModule {
}
TrackerChooserModule.ɵmod = ɵɵdefineNgModule({ type: TrackerChooserModule });
TrackerChooserModule.ɵinj = ɵɵdefineInjector({ factory: function TrackerChooserModule_Factory(t) { return new (t || TrackerChooserModule)(); }, imports: [[
            CommonModule,
            DxSelectBoxModule,
            DxButtonModule,
            DxTextBoxModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(TrackerChooserModule, { declarations: [TrackerChooserComponent], imports: [CommonModule,
        DxSelectBoxModule,
        DxButtonModule,
        DxTextBoxModule], exports: [TrackerChooserComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(TrackerChooserModule, [{
        type: NgModule,
        args: [{
                declarations: [TrackerChooserComponent],
                imports: [
                    CommonModule,
                    DxSelectBoxModule,
                    DxButtonModule,
                    DxTextBoxModule
                ],
                exports: [TrackerChooserComponent]
            }]
    }], null, null); })();

const _c0$3 = ["profilePhotoBtn"];
const _c1$3 = ["profilePhoto"];
class ProfilePhotoUploadComponent {
    constructor(renderer) {
        this.renderer = renderer;
        this.valueChange = new EventEmitter();
        this.loadingChange = new EventEmitter();
    }
    ngOnInit() {
        // Default options
        this.options = Object.assign({
            width: 220,
            height: 250,
            type: 'image/webp',
            quality: undefined,
        }, (this.options || {}));
    }
    changeProfilePhoto(e) {
        this.profilePhotoBtn.nativeElement.click();
    }
    onProfilePhotoUpload(e) {
        const file = e.target.files[0];
        const reader = new FileReader();
        this.loadingChange.emit(true);
        reader.onload = (event) => {
            const img = new Image();
            img.onload = () => {
                smartcrop.crop(img, this.options).then((result) => {
                    const canvas = this.renderer.createElement('canvas');
                    canvas.width = this.options.width;
                    canvas.style.width = this.options.width + 'px';
                    canvas.height = this.options.height;
                    canvas.style.height = this.options.height + 'px';
                    const ctx = canvas.getContext('2d');
                    const crop = result.topCrop;
                    ctx.filter = 'best';
                    ctx.drawImage(img, crop.x, crop.y, crop.width, crop.height, 0, 0, canvas.width, canvas.height);
                    const dataUrl = canvas.toDataURL(this.options.type);
                    this.valueChange.emit(dataUrl);
                    this.profilePhoto.nativeElement.src = dataUrl;
                    this.loadingChange.emit(false);
                });
            };
            img.src = reader.result;
        };
        reader.readAsDataURL(file);
    }
}
ProfilePhotoUploadComponent.ɵfac = function ProfilePhotoUploadComponent_Factory(t) { return new (t || ProfilePhotoUploadComponent)(ɵɵdirectiveInject(Renderer2)); };
ProfilePhotoUploadComponent.ɵcmp = ɵɵdefineComponent({ type: ProfilePhotoUploadComponent, selectors: [["lib-profile-photo-upload"]], viewQuery: function ProfilePhotoUploadComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$3, true);
        ɵɵviewQuery(_c1$3, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.profilePhotoBtn = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.profilePhoto = _t.first);
    } }, inputs: { value: "value", loading: "loading", options: "options" }, outputs: { valueChange: "valueChange", loadingChange: "loadingChange" }, decls: 5, vars: 1, consts: [["width", "220", 3, "src"], ["profilePhoto", ""], ["stylingMode", "text", "text", "Changer", "type", "normal", "width", "100%", 3, "onClick"], ["type", "file", "accept", "image/*", 1, "hidden", 3, "change"], ["profilePhotoBtn", ""]], template: function ProfilePhotoUploadComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "img", 0, 1);
        ɵɵelementStart(2, "dx-button", 2);
        ɵɵlistener("onClick", function ProfilePhotoUploadComponent_Template_dx_button_onClick_2_listener($event) { return ctx.changeProfilePhoto($event); });
        ɵɵelementEnd();
        ɵɵelementStart(3, "input", 3, 4);
        ɵɵlistener("change", function ProfilePhotoUploadComponent_Template_input_change_3_listener($event) { return ctx.onProfilePhotoUpload($event); });
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("src", ctx.value || "assets/images/profile.png", ɵɵsanitizeUrl);
    } }, directives: [DxButtonComponent], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ProfilePhotoUploadComponent, [{
        type: Component,
        args: [{
                selector: 'lib-profile-photo-upload',
                templateUrl: './profile-photo-upload.component.html',
                styleUrls: ['./profile-photo-upload.component.scss']
            }]
    }], function () { return [{ type: Renderer2 }]; }, { profilePhotoBtn: [{
            type: ViewChild,
            args: ['profilePhotoBtn']
        }], profilePhoto: [{
            type: ViewChild,
            args: ['profilePhoto']
        }], value: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], loading: [{
            type: Input
        }], loadingChange: [{
            type: Output
        }], options: [{
            type: Input
        }] }); })();

function ProfileEditFormComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "lib-profile-photo-upload", 24);
    ɵɵlistener("loadingChange", function ProfileEditFormComponent_div_7_Template_lib_profile_photo_upload_loadingChange_1_listener($event) { ɵɵrestoreView(_r2); const ctx_r1 = ɵɵnextContext(); return ctx_r1.loadIndicatorVisible = $event; })("valueChange", function ProfileEditFormComponent_div_7_Template_lib_profile_photo_upload_valueChange_1_listener($event) { ɵɵrestoreView(_r2); const ctx_r3 = ɵɵnextContext(); return ctx_r3.photoChange($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("loading", ctx_r0.loadIndicatorVisible)("value", ctx_r0.user.photo);
} }
const _c0$4 = function () { return { text: "Nom et Pr\u00E8nom" }; };
const _c1$4 = function (a0) { return { value: a0 }; };
const _c2$3 = function () { return { text: "T\u00E9l\u00E9phone" }; };
const _c3$2 = function (a1, a3) { return { mask: "+212 0 00 00 00 00", maskRules: a1, useMaskedValue: true, value: a3 }; };
const _c4$1 = function () { return { text: "Email" }; };
const _c5 = function (a1) { return { readOnly: true, value: a1 }; };
const _c6 = function () { return { of: "#profileForm" }; };
const _c7 = function () { return { text: "Mot de Passe Actuel" }; };
const _c8 = function () { return { mode: "password" }; };
const _c9 = function () { return { text: "Nouveau Mot de Passe" }; };
const _c10 = function () { return { text: "Confirmation du Mot de Passe" }; };
class ProfileEditFormComponent {
    constructor(profileService, user) {
        this.profileService = profileService;
        this.user = user;
        this.buttonOptions = {
            text: 'Enregistrer',
            type: 'default',
            useSubmitBehavior: true
        };
        this.passwordChangeRequest = new PasswordChangeRequest();
        this.changePasswordBtnOptions = {
            text: 'Changer',
            type: 'default',
            useSubmitBehavior: true
        };
        this.phonePattern = /^\+\s*212\s*\d\s*\d{2}\s*\d{2}\s*\d{2}\s*\d{2}$/;
        this.loadIndicatorVisible = false;
        this.passwordComparison = this.passwordComparison.bind(this);
    }
    ngOnInit() {
        this.newUser = {};
    }
    passwordComparison() {
        return this.passwordChangeRequest.new_password;
    }
    onFormSubmit(e) {
        e.preventDefault();
        this.loadIndicatorVisible = true;
        this.profileService.update(this.newUser).pipe(catchError((error) => {
            this.loadIndicatorVisible = false;
            return throwError(error);
        })).subscribe(_ => {
            notify('Profil mis à jour avec succès');
            Object.assign(this.user, this.newUser);
            this.newUser = {};
            this.loadIndicatorVisible = false;
        });
    }
    onChangePasswordSubmit(e) {
        e.preventDefault();
        this.profileService.changePassword(this.passwordChangeRequest).subscribe(_ => {
            notify('Le mot de passe a été changé avec succès');
        });
    }
    onFieldDataChanged(e) {
        Object.assign(this.newUser, e.component.option('formData'));
    }
    photoChange(e) {
        this.loadIndicatorVisible = true;
        this.profileService.update({ photo: e }).pipe(catchError((error) => {
            this.loadIndicatorVisible = false;
            return throwError(error);
        })).subscribe(_ => {
            notify('Photo mis à jour avec succès');
            this.user.photo = e;
            this.loadIndicatorVisible = false;
        });
    }
}
ProfileEditFormComponent.ɵfac = function ProfileEditFormComponent_Factory(t) { return new (t || ProfileEditFormComponent)(ɵɵdirectiveInject(ProfileService), ɵɵdirectiveInject(User)); };
ProfileEditFormComponent.ɵcmp = ɵɵdefineComponent({ type: ProfileEditFormComponent, selectors: [["lib-profile-edit-form"]], decls: 31, vars: 52, consts: [[1, "flex", "items-stretch"], [1, "p-8", "flex-1"], ["id", "profileForm", "enctype", "multipart/form-data", 3, "submit"], ["id", "profileEditForm", 3, "colCount", "readOnly", "showColonAfterLabel", "showValidationSummary", "onFieldDataChanged"], ["itemType", "group"], [4, "dxTemplate"], ["itemType", "group", "caption", "Donn\u00E9es Personnelles", 3, "colSpan"], ["dataField", "name", 3, "label", "editorOptions"], ["type", "required"], ["dataField", "phone", 3, "label", "editorOptions"], ["type", "pattern", 3, "pattern"], ["type", "stringLength", 3, "max"], ["dataField", "email", 3, "label", "editorOptions"], ["itemType", "button", "horizontalAlignment", "right", 3, "colSpan", "buttonOptions"], ["shadingColor", "rgba(0,0,0,0.4)", 3, "position", "visible", "showIndicator", "showPane", "shading", "closeOnOutsideClick", "visibleChange"], [3, "submit"], ["id", "passwordChangeForm", 3, "formData", "readOnly", "showColonAfterLabel", "showValidationSummary"], ["itemType", "group", "caption", "Changer le mot de passe"], ["dataField", "old_password", 3, "label", "editorOptions"], ["dataField", "new_password", 3, "label", "editorOptions"], ["type", "stringLength", "message", "La longueur minimale du mot de passe est de 8 caract\u00E8res", 3, "min", "max"], ["dataField", "new_password_confirm", 3, "label", "editorOptions"], ["type", "compare", "message", "La confirmation du mot de passe ne correspond pas", 3, "comparisonTarget"], ["itemType", "button", "horizontalAlignment", "right", 3, "buttonOptions"], [3, "loading", "value", "loadingChange", "valueChange"]], template: function ProfileEditFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "dx-scroll-view");
        ɵɵelementStart(1, "div", 0);
        ɵɵelementStart(2, "div", 1);
        ɵɵelementStart(3, "form", 2);
        ɵɵlistener("submit", function ProfileEditFormComponent_Template_form_submit_3_listener($event) { return ctx.onFormSubmit($event); });
        ɵɵelementStart(4, "dx-form", 3);
        ɵɵlistener("onFieldDataChanged", function ProfileEditFormComponent_Template_dx_form_onFieldDataChanged_4_listener($event) { return ctx.onFieldDataChanged($event); });
        ɵɵelementStart(5, "dxi-item", 4);
        ɵɵelementStart(6, "dxi-item");
        ɵɵtemplate(7, ProfileEditFormComponent_div_7_Template, 2, 2, "div", 5);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(8, "dxi-item", 6);
        ɵɵelementStart(9, "dxi-item", 7);
        ɵɵelement(10, "dxi-validation-rule", 8);
        ɵɵelementEnd();
        ɵɵelementStart(11, "dxi-item", 9);
        ɵɵelement(12, "dxi-validation-rule", 8);
        ɵɵelement(13, "dxi-validation-rule", 10);
        ɵɵelement(14, "dxi-validation-rule", 11);
        ɵɵelementEnd();
        ɵɵelement(15, "dxi-item", 12);
        ɵɵelementEnd();
        ɵɵelement(16, "dxi-item", 13);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(17, "dx-load-panel", 14);
        ɵɵlistener("visibleChange", function ProfileEditFormComponent_Template_dx_load_panel_visibleChange_17_listener($event) { return ctx.loadIndicatorVisible = $event; });
        ɵɵelementEnd();
        ɵɵelementStart(18, "div", 1);
        ɵɵelementStart(19, "form", 15);
        ɵɵlistener("submit", function ProfileEditFormComponent_Template_form_submit_19_listener($event) { return ctx.onChangePasswordSubmit($event); });
        ɵɵelementStart(20, "dx-form", 16);
        ɵɵelementStart(21, "dxi-item", 17);
        ɵɵelementStart(22, "dxi-item", 18);
        ɵɵelement(23, "dxi-validation-rule", 8);
        ɵɵelementEnd();
        ɵɵelementStart(24, "dxi-item", 19);
        ɵɵelement(25, "dxi-validation-rule", 8);
        ɵɵelement(26, "dxi-validation-rule", 20);
        ɵɵelementEnd();
        ɵɵelementStart(27, "dxi-item", 21);
        ɵɵelement(28, "dxi-validation-rule", 8);
        ɵɵelement(29, "dxi-validation-rule", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(30, "dxi-item", 23);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(4);
        ɵɵproperty("colCount", 4)("readOnly", false)("showColonAfterLabel", true)("showValidationSummary", true);
        ɵɵadvance(4);
        ɵɵproperty("colSpan", 3);
        ɵɵadvance(1);
        ɵɵproperty("label", ɵɵpureFunction0(35, _c0$4))("editorOptions", ɵɵpureFunction1(36, _c1$4, ctx.user.name));
        ɵɵadvance(2);
        ɵɵproperty("label", ɵɵpureFunction0(38, _c2$3))("editorOptions", ɵɵpureFunction2(39, _c3$2, ctx.phonePattern, ctx.user.phone));
        ɵɵadvance(2);
        ɵɵproperty("pattern", ctx.phonePattern);
        ɵɵadvance(1);
        ɵɵproperty("max", 45);
        ɵɵadvance(1);
        ɵɵproperty("label", ɵɵpureFunction0(42, _c4$1))("editorOptions", ɵɵpureFunction1(43, _c5, ctx.user.email));
        ɵɵadvance(1);
        ɵɵproperty("colSpan", 4)("buttonOptions", ctx.buttonOptions);
        ɵɵadvance(1);
        ɵɵproperty("position", ɵɵpureFunction0(45, _c6))("visible", ctx.loadIndicatorVisible)("showIndicator", true)("showPane", true)("shading", true)("closeOnOutsideClick", false);
        ɵɵadvance(3);
        ɵɵproperty("formData", ctx.passwordChangeRequest)("readOnly", false)("showColonAfterLabel", true)("showValidationSummary", true);
        ɵɵadvance(2);
        ɵɵproperty("label", ɵɵpureFunction0(46, _c7))("editorOptions", ɵɵpureFunction0(47, _c8));
        ɵɵadvance(2);
        ɵɵproperty("label", ɵɵpureFunction0(48, _c9))("editorOptions", ɵɵpureFunction0(49, _c8));
        ɵɵadvance(2);
        ɵɵproperty("min", 8)("max", 150);
        ɵɵadvance(1);
        ɵɵproperty("label", ɵɵpureFunction0(50, _c10))("editorOptions", ɵɵpureFunction0(51, _c8));
        ɵɵadvance(2);
        ɵɵproperty("comparisonTarget", ctx.passwordComparison);
        ɵɵadvance(1);
        ɵɵproperty("buttonOptions", ctx.changePasswordBtnOptions);
    } }, directives: [DxScrollViewComponent, DxFormComponent, DxiItemComponent, DxTemplateDirective, DxiValidationRuleComponent, DxLoadPanelComponent, ProfilePhotoUploadComponent], styles: ["[_nghost-%COMP%]   dx-scroll-view[_ngcontent-%COMP%]{background-color:#fff}  #save-button .button-indicator{display:inline-block;height:18px;margin-right:5px;vertical-align:middle;width:18px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ProfileEditFormComponent, [{
        type: Component,
        args: [{
                selector: 'lib-profile-edit-form',
                templateUrl: './profile-edit-form.component.html',
                styleUrls: ['./profile-edit-form.component.scss']
            }]
    }], function () { return [{ type: ProfileService }, { type: User }]; }, null); })();

class ProfilePhotoUploadModule {
}
ProfilePhotoUploadModule.ɵmod = ɵɵdefineNgModule({ type: ProfilePhotoUploadModule });
ProfilePhotoUploadModule.ɵinj = ɵɵdefineInjector({ factory: function ProfilePhotoUploadModule_Factory(t) { return new (t || ProfilePhotoUploadModule)(); }, imports: [[
            CommonModule,
            DxButtonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ProfilePhotoUploadModule, { declarations: [ProfilePhotoUploadComponent], imports: [CommonModule,
        DxButtonModule], exports: [ProfilePhotoUploadComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ProfilePhotoUploadModule, [{
        type: NgModule,
        args: [{
                declarations: [ProfilePhotoUploadComponent],
                imports: [
                    CommonModule,
                    DxButtonModule
                ],
                exports: [ProfilePhotoUploadComponent]
            }]
    }], null, null); })();

class ProfileEditFormModule {
}
ProfileEditFormModule.ɵmod = ɵɵdefineNgModule({ type: ProfileEditFormModule });
ProfileEditFormModule.ɵinj = ɵɵdefineInjector({ factory: function ProfileEditFormModule_Factory(t) { return new (t || ProfileEditFormModule)(); }, imports: [[
            CommonModule,
            DxFormModule,
            DxScrollViewModule,
            DxFileUploaderModule,
            DxButtonModule,
            DxLoadIndicatorModule,
            DxLoadPanelModule,
            ProfilePhotoUploadModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ProfileEditFormModule, { declarations: [ProfileEditFormComponent], imports: [CommonModule,
        DxFormModule,
        DxScrollViewModule,
        DxFileUploaderModule,
        DxButtonModule,
        DxLoadIndicatorModule,
        DxLoadPanelModule,
        ProfilePhotoUploadModule], exports: [ProfileEditFormComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ProfileEditFormModule, [{
        type: NgModule,
        args: [{
                declarations: [ProfileEditFormComponent],
                imports: [
                    CommonModule,
                    DxFormModule,
                    DxScrollViewModule,
                    DxFileUploaderModule,
                    DxButtonModule,
                    DxLoadIndicatorModule,
                    DxLoadPanelModule,
                    ProfilePhotoUploadModule,
                ],
                exports: [ProfileEditFormComponent]
            }]
    }], null, null); })();

class TagAttributesEditorComponent {
    constructor() {
        this.attributesChange = new EventEmitter();
        this.save = this.save.bind(this);
    }
    set attributes(attrs) {
        this.ds = new DataSource({
            // key: 'name',
            store: {
                type: 'array',
                // key: 'name',
                data: attrs || []
            },
            paginate: false
        });
    }
    ngOnInit() {
        /*if (!this.attributes) {
          this.attributes = [];
        }*/
        this.parentSaveClick.pipe(first()).subscribe((parent) => {
            this.grid.instance.saveEditData().then(() => {
                this.attributesChange.emit(this.ds.items());
                parent.saveEditData();
            });
        });
        this.parentCancelClick.pipe(first()).subscribe((parent) => {
            this.grid.instance.cancelEditData();
            parent.cancelEditData();
        });
    }
    onToolbarPreparing(e) {
        e.toolbarOptions.items[1].visible = false;
        /*e.toolbarOptions.items[1].onClick = () => {
          e.component.saveEditData().then(() => {
            console.log(this.attributes);
            this.attributesChange.emit(this.ds.items());
          });
        };*/
    }
    save(e) {
        // this.attributesChange.emit(this.ds.items());
    }
}
TagAttributesEditorComponent.ɵfac = function TagAttributesEditorComponent_Factory(t) { return new (t || TagAttributesEditorComponent)(); };
TagAttributesEditorComponent.ɵcmp = ɵɵdefineComponent({ type: TagAttributesEditorComponent, selectors: [["lib-tag-attributes-editor"]], viewQuery: function TagAttributesEditorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(DxDataGridComponent, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.grid = _t.first);
    } }, inputs: { parentSaveClick: "parentSaveClick", parentCancelClick: "parentCancelClick", attributes: "attributes" }, outputs: { attributesChange: "attributesChange" }, decls: 6, vars: 7, consts: [[3, "dataSource", "showBorders", "showRowLines", "columnAutoWidth", "onToolbarPreparing"], ["mode", "batch", 3, "allowDeleting", "allowAdding", "allowUpdating"], ["caption", "Nom", "dataField", "name", "dataType", "string", "width", "30%"], ["type", "required"], ["caption", "Valeur", "dataField", "value", "dataType", "string"]], template: function TagAttributesEditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "dx-data-grid", 0);
        ɵɵlistener("onToolbarPreparing", function TagAttributesEditorComponent_Template_dx_data_grid_onToolbarPreparing_0_listener($event) { return ctx.onToolbarPreparing($event); });
        ɵɵelement(1, "dxo-editing", 1);
        ɵɵelementStart(2, "dxi-column", 2);
        ɵɵelement(3, "dxi-validation-rule", 3);
        ɵɵelementEnd();
        ɵɵelementStart(4, "dxi-column", 4);
        ɵɵelement(5, "dxi-validation-rule", 3);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("dataSource", ctx.ds)("showBorders", true)("showRowLines", true)("columnAutoWidth", true);
        ɵɵadvance(1);
        ɵɵproperty("allowDeleting", true)("allowAdding", true)("allowUpdating", true);
    } }, directives: [DxDataGridComponent, DxoEditingComponent, DxiColumnComponent, DxiValidationRuleComponent], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TagAttributesEditorComponent, [{
        type: Component,
        args: [{
                selector: 'lib-tag-attributes-editor',
                templateUrl: './tag-attributes-editor.component.html',
                styleUrls: ['./tag-attributes-editor.component.scss']
            }]
    }], function () { return []; }, { grid: [{
            type: ViewChild,
            args: [DxDataGridComponent]
        }], parentSaveClick: [{
            type: Input
        }], parentCancelClick: [{
            type: Input
        }], attributes: [{
            type: Input
        }], attributesChange: [{
            type: Output
        }] }); })();

class TagAttributesEditorModule {
}
TagAttributesEditorModule.ɵmod = ɵɵdefineNgModule({ type: TagAttributesEditorModule });
TagAttributesEditorModule.ɵinj = ɵɵdefineInjector({ factory: function TagAttributesEditorModule_Factory(t) { return new (t || TagAttributesEditorModule)(); }, imports: [[
            CommonModule,
            DxDataGridModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(TagAttributesEditorModule, { declarations: [TagAttributesEditorComponent], imports: [CommonModule,
        DxDataGridModule], exports: [TagAttributesEditorComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(TagAttributesEditorModule, [{
        type: NgModule,
        args: [{
                declarations: [TagAttributesEditorComponent],
                imports: [
                    CommonModule,
                    DxDataGridModule
                ],
                exports: [TagAttributesEditorComponent]
            }]
    }], null, null); })();

function BadgeComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "span");
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵclassMapInterpolate1("w-2 h-2 rounded-full mr-1 bg-", ctx_r0.dotColor || ctx_r0.color, "-400");
} }
const _c0$5 = ["*"];
class BadgeComponent {
    constructor() {
        this.color = 'green';
        this.showDot = false;
    }
    ngOnInit() {
    }
}
BadgeComponent.ɵfac = function BadgeComponent_Factory(t) { return new (t || BadgeComponent)(); };
BadgeComponent.ɵcmp = ɵɵdefineComponent({ type: BadgeComponent, selectors: [["lib-badge"]], inputs: { color: "color", showDot: "showDot", dotColor: "dotColor" }, ngContentSelectors: _c0$5, decls: 3, vars: 6, consts: [[3, "class", 4, "ngIf"]], template: function BadgeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "span");
        ɵɵtemplate(1, BadgeComponent_span_1_Template, 1, 3, "span", 0);
        ɵɵprojection(2);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵclassMapInterpolate3("px-2 h-5 rounded-full text-xs font-semibold inline-flex items-center cursor-pointer\n    bg-", ctx.color, "-100 text-", ctx.color, "-700 hover:bg-", ctx.color, "-500 hover:text-white");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showDot);
    } }, directives: [NgIf], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(BadgeComponent, [{
        type: Component,
        args: [{
                selector: 'lib-badge',
                templateUrl: './badge.component.html',
                styleUrls: ['./badge.component.scss']
            }]
    }], function () { return []; }, { color: [{
            type: Input
        }], showDot: [{
            type: Input
        }], dotColor: [{
            type: Input
        }] }); })();

class BadgeModule {
}
BadgeModule.ɵmod = ɵɵdefineNgModule({ type: BadgeModule });
BadgeModule.ɵinj = ɵɵdefineInjector({ factory: function BadgeModule_Factory(t) { return new (t || BadgeModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(BadgeModule, { declarations: [BadgeComponent], imports: [CommonModule], exports: [BadgeComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(BadgeModule, [{
        type: NgModule,
        args: [{
                declarations: [BadgeComponent],
                imports: [
                    CommonModule
                ],
                exports: [BadgeComponent]
            }]
    }], null, null); })();

class TagsViewerService extends StoreService {
    constructor(http, config, errors) {
        super(http, config, errors);
        this.initStore(Tag);
    }
    load(queryParams) {
        return this.http.get(this.config.apiVerUrl('/app/tags'), { params: queryParams });
    }
    insert(values) {
        return this.http.post(this.config.apiVerUrl('/app/tags'), values);
    }
    remove(id) {
        return this.http.delete(this.config.apiVerUrl(`/app/tags/${id}`));
    }
    update(id, values) {
        return this.http.put(this.config.apiVerUrl(`/app/tags/${id}`), values);
    }
    checkCode(code, id) {
        return this.http.post(this.config.apiVerUrl('/app/tags/check-code'), { code, id });
    }
}
TagsViewerService.ɵfac = function TagsViewerService_Factory(t) { return new (t || TagsViewerService)(ɵɵinject(HttpClient), ɵɵinject(ConfigService), ɵɵinject(ErrorsService)); };
TagsViewerService.ɵprov = ɵɵdefineInjectable({ token: TagsViewerService, factory: TagsViewerService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TagsViewerService, [{
        type: Injectable,
        args: [{
                deps: [HttpClient],
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }, { type: ConfigService }, { type: ErrorsService }]; }, null); })();

class GridDefaultDirective {
    constructor(grid) {
        this.grid = grid;
        this.grid.allowColumnReordering = true;
        this.grid.allowColumnResizing = true;
        this.grid.columnHidingEnabled = true;
        this.grid.errorRowEnabled = false;
        this.grid.showBorders = false;
        this.grid.showRowLines = true;
        this.grid.remoteOperations = { paging: true, sorting: true, filtering: true };
        this.grid.rowAlternationEnabled = true;
        this.grid.columnAutoWidth = true;
        this.grid.grouping = { contextMenuEnabled: true };
        this.stateStoring();
    }
    ngOnInit() {
        this.sub = this.grid.onToolbarPreparing.subscribe((e) => {
            e.toolbarOptions.items.splice(e.toolbarOptions.items.length - 2, 0, {
                location: 'after',
                widget: 'dxButton',
                options: {
                    hint: 'Réinitialiser les paramètres du tableau',
                    icon: 'clearformat',
                    onClick: () => {
                        localStorage.removeItem(this.getStorageKey());
                        this.grid.instance.state(null);
                    }
                },
            }, {
                location: 'after',
                widget: 'dxButton',
                options: {
                    hint: 'Actualiser',
                    icon: 'refresh',
                    onClick: () => {
                        this.grid.instance.refresh();
                    }
                },
            });
        });
    }
    stateStoring() {
        this.grid.stateStoring = {
            enabled: true,
            type: 'custom',
            customLoad: () => {
                return JSON.parse(localStorage.getItem(this.getStorageKey()));
            },
            customSave: (state) => {
                localStorage.setItem(this.getStorageKey(), JSON.stringify({
                    columns: state.columns,
                    allowedPageSizes: state.allowedPageSizes,
                    pageSize: state.pageSize,
                }));
            },
        };
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
    }
    getStorageKey() {
        return this.options.stateStorageKey + '-v0.7.0';
    }
}
GridDefaultDirective.ɵfac = function GridDefaultDirective_Factory(t) { return new (t || GridDefaultDirective)(ɵɵdirectiveInject(DxDataGridComponent)); };
GridDefaultDirective.ɵdir = ɵɵdefineDirective({ type: GridDefaultDirective, selectors: [["", "libGridDefault", ""]], inputs: { options: ["libGridDefault", "options"] } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(GridDefaultDirective, [{
        type: Directive,
        args: [{
                selector: '[libGridDefault]'
            }]
    }], function () { return [{ type: DxDataGridComponent }]; }, { options: [{
            type: Input,
            args: ['libGridDefault']
        }] }); })();

function TagsViewerComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "lib-tag-attributes-editor", 36);
    ɵɵlistener("attributesChange", function TagsViewerComponent_div_16_Template_lib_tag_attributes_editor_attributesChange_1_listener($event) { ɵɵrestoreView(_r5); const cellInfo_r3 = ctx.$implicit; return cellInfo_r3.setValue($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const cellInfo_r3 = ctx.$implicit;
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("attributes", cellInfo_r3.value)("parentSaveClick", ctx_r0.editSaveClick$)("parentCancelClick", ctx_r0.editCancelClick$);
} }
function TagsViewerComponent_div_41_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "span", 42);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const data_r8 = ctx.$implicit;
    ɵɵadvance(2);
    ɵɵtextInterpolate(data_r8.value);
} }
function TagsViewerComponent_div_41_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "dx-data-grid", 37);
    ɵɵelement(2, "dxi-column", 38);
    ɵɵelement(3, "dxi-column", 39);
    ɵɵtemplate(4, TagsViewerComponent_div_41_div_4_Template, 3, 1, "div", 13);
    ɵɵelementEnd();
    ɵɵelementStart(5, "div", 40);
    ɵɵelementStart(6, "dx-button", 41);
    ɵɵlistener("onClick", function TagsViewerComponent_div_41_Template_dx_button_onClick_6_listener() { ɵɵrestoreView(_r10); const cell_r6 = ctx.$implicit; const ctx_r9 = ɵɵnextContext(); return ctx_r9.addTagAttr(cell_r6.rowIndex); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const cell_r6 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("dataSource", cell_r6.data.attributes)("showBorders", true)("showColumnLines", true)("showRowLines", true)("showColumnHeaders", false)("columnAutoWidth", true);
    ɵɵadvance(3);
    ɵɵproperty("dxTemplateOf", "cellTemplate");
    ɵɵadvance(2);
    ɵɵproperty("width", 120);
} }
function TagsViewerComponent_div_42_div_2_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 48);
    ɵɵtext(1);
    ɵɵelementStart(2, "b");
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const attr_r15 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", attr_r15.name, " : ");
    ɵɵadvance(2);
    ɵɵtextInterpolate(attr_r15.value);
} }
function TagsViewerComponent_div_42_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", 44);
    ɵɵelementStart(2, "div");
    ɵɵelementStart(3, "span", 45);
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵelementStart(6, "div", 46);
    ɵɵtemplate(7, TagsViewerComponent_div_42_div_2_span_7_Template, 4, 2, "span", 47);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const tag_r13 = ctx.$implicit;
    ɵɵadvance(4);
    ɵɵtextInterpolate(tag_r13.code);
    ɵɵadvance(1);
    ɵɵtextInterpolate2(" - ", tag_r13.category, " - ", tag_r13.type, " ");
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", tag_r13.attributes);
} }
const _c0$6 = function () { return ["code", "type", "category"]; };
function TagsViewerComponent_div_42_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "dx-select-box", 43);
    ɵɵlistener("onSelectionChanged", function TagsViewerComponent_div_42_Template_dx_select_box_onSelectionChanged_1_listener($event) { ɵɵrestoreView(_r17); const ctx_r16 = ɵɵnextContext(); return ctx_r16.assignTag($event); });
    ɵɵtemplate(2, TagsViewerComponent_div_42_div_2_Template, 8, 4, "div", 13);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("dataSource", ctx_r2.selectorDs)("width", 450)("searchEnabled", true)("searchExpr", ɵɵpureFunction0(5, _c0$6));
    ɵɵadvance(1);
    ɵɵproperty("dxTemplateOf", "tagTemplate");
} }
const _c1$5 = function () { return { stateStorageKey: "app-tags-viewer-grid" }; };
const _c2$4 = function () { return { enabled: false, template: "details" }; };
const _c3$3 = function () { return { visible: false }; };
const _c4$2 = function () { return [25, 50, 100]; };
class TagsViewerComponent {
    constructor(tagService, user) {
        this.tagService = tagService;
        this.user = user;
        this.tagTypes = tagTypes;
        this.editSaveClick = new Subject();
        this.editSaveClick$ = this.editSaveClick.asObservable();
        this.editCancelClick = new Subject();
        this.editCancelClick$ = this.editCancelClick.asObservable();
        this.editToolbarItems = [{
                toolbar: 'bottom',
                location: 'after',
                widget: 'dxButton',
                options: {
                    text: 'Sauvegrader',
                    onClick: (e) => {
                        this.editSaveClick.next(this.grid.instance);
                    }
                }
            }, {
                toolbar: 'bottom',
                location: 'after',
                widget: 'dxButton',
                options: {
                    text: 'Annuler',
                    onClick: (e) => {
                        this.editCancelClick.next(this.grid.instance);
                    }
                }
            }];
        // Data source
        this.ds = this.tagService.newDataSource();
        // Selector Data source
        this.selectorDs = this.tagService.newDataSource();
        // Permissions
        this.canEdit = user.can('edit tags');
        this.canAdd = user.can('add tags');
        this.canDelete = user.can('delete tags');
        // Bindings
        this.codeValidation = this.codeValidation.bind(this);
        this.showAttributes = this.showAttributes.bind(this);
        this.addTagAttr = this.addTagAttr.bind(this);
        this.assignTag = this.assignTag.bind(this);
        this.detachTag = this.detachTag.bind(this);
        this.cloneTag = this.cloneTag.bind(this);
        this.checkClone = this.checkClone.bind(this);
    }
    ngOnInit() {
    }
    codeValidation(params) {
        var _a;
        return this.tagService.checkCode(params.value, (_a = params.data) === null || _a === void 0 ? void 0 : _a.id).toPromise();
    }
    showAttributes(e) {
        e.component.collapseAll(-1);
        if (this.expandedAlertRowKey === e.row.key) {
            this.expandedAlertRowKey = 0;
            return;
        }
        e.component.expandRow(e.row.key);
        this.expandedAlertRowKey = e.row.key;
    }
    addTagAttr(index) {
        this.grid.instance.editRow(index);
    }
    ngOnChanges(changes) {
        if (changes.taggable) {
            // Categories
            this.tagCategories = taggableTypeTagCategories.get(this.taggable.taggable_type);
            // Data
            this.ds.filter([
                ['taggable_id', '=', this.taggable.taggable_id],
                ['taggable_type', '=', this.taggable.taggable_type]
            ]);
            this.selectorDs.filter([
                ['taggable_id', '=', null],
                ['domain_id', '=', this.taggable.taggable_domain_id],
                ['category_id', '=', this.tagCategories.map(c => c.id)],
            ]);
            if (!changes.firstChange) {
                this.ds.reload();
                this.selectorDs.reload();
            }
        }
    }
    assignTaggable(e) {
        e.data.taggable_id = this.taggable.taggable_id;
        e.data.taggable_type = this.taggable.taggable_type;
        e.data.domain_id = this.taggable.taggable_domain_id;
    }
    assignTag(e) {
        if (!e.selectedItem) {
            return;
        }
        this.tagService.update(e.selectedItem.id, {
            taggable_id: this.taggable.taggable_id,
            taggable_type: this.taggable.taggable_type,
        }).subscribe(() => {
            e.component.reset();
            e.component.close();
            this.ds.reload();
            this.selectorDs.reload();
        });
    }
    detachTag(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield confirm('Voulez-vous vraiment détacher cette carte?', 'Confirmation');
            if (!result) {
                return;
            }
            this.tagService.update(e.row.data.id, {
                taggable_id: 0,
                taggable_type: null,
            }).subscribe(() => {
                this.ds.reload();
                this.selectorDs.reload();
            });
        });
    }
    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            /*widget: 'dxLookup',
            options: {
              dataSource: this.selectorDs,
              itemTemplate: 'tagSelectorItemTemplate',
              width: '100%',
            }
            // */
            template: 'tagsSelectorTemplate',
        });
    }
    checkClone(e) {
        if (!this.cloned) {
            return;
        }
        e.data = Object.assign({}, this.cloned);
        delete e.data.id;
        delete e.data.code;
        e.data.attributes.map(a => delete a.id);
        this.cloned = null;
    }
    cloneTag(e) {
        this.cloned = e.row.data;
        this.grid.instance.addRow();
    }
}
TagsViewerComponent.ɵfac = function TagsViewerComponent_Factory(t) { return new (t || TagsViewerComponent)(ɵɵdirectiveInject(TagsViewerService), ɵɵdirectiveInject(User)); };
TagsViewerComponent.ɵcmp = ɵɵdefineComponent({ type: TagsViewerComponent, selectors: [["lib-tags-viewer"]], viewQuery: function TagsViewerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(DxDataGridComponent, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.grid = _t.first);
    } }, inputs: { taggable: "taggable" }, features: [ɵɵNgOnChangesFeature], decls: 43, vars: 58, consts: [["id", "tagsViewerGridContainer", 3, "dataSource", "libGridDefault", "masterDetail", "onRowInserting", "onInitNewRow", "onToolbarPreparing"], ["caption", "ID", "dataField", "id", "sortOrder", "desc", "dataType", "number", 3, "allowEditing", "formItem"], ["caption", "Code", "dataField", "code", "dataType", "number"], ["type", "required"], ["type", "async", "message", "Code existe d\u00E9j\u00E0", 3, "validationCallback"], ["caption", "Type", "dataField", "type", 3, "allowEditing", "formItem"], ["caption", "Categorie", "dataField", "category", 3, "allowEditing", "formItem"], ["caption", "Date cr\u00E9ation", "dataField", "created_at", "format", "shortDateShortTime", "dataType", "date", 3, "allowEditing", "formItem"], ["caption", "Date modification", "dataField", "updated_at", "format", "shortDateShortTime", "dataType", "date", 3, "allowEditing", "formItem"], ["caption", "Type", "dataField", "type_id", 3, "visible", "showInColumnChooser"], ["valueExpr", "id", "displayExpr", "name", 3, "dataSource"], ["caption", "Categorie", "dataField", "category_id", 3, "visible", "showInColumnChooser"], ["dataField", "attributes", "caption", "", "editCellTemplate", "attributesSelector", 3, "showInColumnChooser", "allowFiltering", "allowSearch", "visible"], [4, "dxTemplate", "dxTemplateOf"], ["type", "buttons", 3, "allowHiding", "width"], ["hint", "D\u00E9tacher la carte", "icon", "close", 3, "onClick"], ["hint", "Liste des attribus", "icon", "info", 3, "onClick"], ["hint", "Dupliquer la carte", "icon", "copy", 3, "onClick"], ["name", "edit"], ["name", "delete"], ["mode", "popup", 3, "allowDeleting", "allowAdding", "allowUpdating"], ["width", "50%", 3, "toolbarItems"], ["labelLocation", "top"], ["itemType", "group", "colSpan", "2", "colCount", "2", "caption", "G\u00E9n\u00E9ral"], ["dataField", "code"], ["dataField", "type_id"], ["dataField", "category_id"], ["itemType", "group", "colSpan", "2", "colCount", "1", "caption", "Attributs"], ["dataField", "attributes", 3, "label"], ["mode", "select", 3, "enabled"], [3, "visible"], ["fileName", "liste-cartes-", 3, "enabled", "allowExportSelectedData"], ["mode", "multiple"], [3, "pageSize"], [3, "showPageSizeSelector", "allowedPageSizes", "showInfo"], [3, "visible", "width"], [3, "attributes", "parentSaveClick", "parentCancelClick", "attributesChange"], [3, "dataSource", "showBorders", "showColumnLines", "showRowLines", "showColumnHeaders", "columnAutoWidth"], ["cellTemplate", "cellTemplate", "caption", "Nom", "dataField", "name", "dataType", "string", "width", "10%"], ["caption", "Valeur", "dataField", "value", "dataType", "string"], [1, "py-2"], ["type", "default", "text", "Ajouter", 3, "width", "onClick"], [1, "underline"], ["placeholder", "S\u00E9lectionnez une carte...", "searchMode", "contains", "itemTemplate", "tagTemplate", 3, "dataSource", "width", "searchEnabled", "searchExpr", "onSelectionChanged"], [1, "p-1"], [1, "font-bold"], [1, "mt-1", "flex", "items-center", "justify-start"], ["class", "first:ml-0 p-1 m-1 bg-gray-200 rounded text-xs", 4, "ngFor", "ngForOf"], [1, "first:ml-0", "p-1", "m-1", "bg-gray-200", "rounded", "text-xs"]], template: function TagsViewerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "dx-data-grid", 0);
        ɵɵlistener("onRowInserting", function TagsViewerComponent_Template_dx_data_grid_onRowInserting_0_listener($event) { return ctx.assignTaggable($event); })("onInitNewRow", function TagsViewerComponent_Template_dx_data_grid_onInitNewRow_0_listener($event) { return ctx.checkClone($event); })("onToolbarPreparing", function TagsViewerComponent_Template_dx_data_grid_onToolbarPreparing_0_listener($event) { return ctx.onToolbarPreparing($event); });
        ɵɵelement(1, "dxi-column", 1);
        ɵɵelementStart(2, "dxi-column", 2);
        ɵɵelement(3, "dxi-validation-rule", 3);
        ɵɵelement(4, "dxi-validation-rule", 4);
        ɵɵelementEnd();
        ɵɵelement(5, "dxi-column", 5);
        ɵɵelement(6, "dxi-column", 6);
        ɵɵelement(7, "dxi-column", 7);
        ɵɵelement(8, "dxi-column", 8);
        ɵɵelementStart(9, "dxi-column", 9);
        ɵɵelement(10, "dxo-lookup", 10);
        ɵɵelement(11, "dxi-validation-rule", 3);
        ɵɵelementEnd();
        ɵɵelementStart(12, "dxi-column", 11);
        ɵɵelement(13, "dxo-lookup", 10);
        ɵɵelement(14, "dxi-validation-rule", 3);
        ɵɵelementEnd();
        ɵɵelementStart(15, "dxi-column", 12);
        ɵɵtemplate(16, TagsViewerComponent_div_16_Template, 2, 3, "div", 13);
        ɵɵelementEnd();
        ɵɵelementStart(17, "dxi-column", 14);
        ɵɵelement(18, "dxi-button", 15);
        ɵɵelement(19, "dxi-button", 16);
        ɵɵelement(20, "dxi-button", 17);
        ɵɵelement(21, "dxi-button", 18);
        ɵɵelement(22, "dxi-button", 19);
        ɵɵelementEnd();
        ɵɵelementStart(23, "dxo-editing", 20);
        ɵɵelement(24, "dxo-popup", 21);
        ɵɵelementStart(25, "dxo-form", 22);
        ɵɵelementStart(26, "dxi-item", 23);
        ɵɵelement(27, "dxi-item", 24);
        ɵɵelement(28, "dxi-item", 25);
        ɵɵelement(29, "dxi-item", 26);
        ɵɵelementEnd();
        ɵɵelementStart(30, "dxi-item", 27);
        ɵɵelement(31, "dxi-item", 28);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(32, "dxo-column-chooser", 29);
        ɵɵelement(33, "dxo-group-panel", 30);
        ɵɵelement(34, "dxo-export", 31);
        ɵɵelement(35, "dxo-sorting", 32);
        ɵɵelement(36, "dxo-paging", 33);
        ɵɵelement(37, "dxo-pager", 34);
        ɵɵelement(38, "dxo-filter-row", 30);
        ɵɵelement(39, "dxo-search-panel", 35);
        ɵɵelement(40, "dxo-header-filter", 30);
        ɵɵtemplate(41, TagsViewerComponent_div_41_Template, 7, 8, "div", 13);
        ɵɵtemplate(42, TagsViewerComponent_div_42_Template, 3, 6, "div", 13);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("dataSource", ctx.ds)("libGridDefault", ɵɵpureFunction0(49, _c1$5))("masterDetail", ɵɵpureFunction0(50, _c2$4));
        ɵɵadvance(1);
        ɵɵproperty("allowEditing", false)("formItem", ɵɵpureFunction0(51, _c3$3));
        ɵɵadvance(3);
        ɵɵproperty("validationCallback", ctx.codeValidation);
        ɵɵadvance(1);
        ɵɵproperty("allowEditing", false)("formItem", ɵɵpureFunction0(52, _c3$3));
        ɵɵadvance(1);
        ɵɵproperty("allowEditing", false)("formItem", ɵɵpureFunction0(53, _c3$3));
        ɵɵadvance(1);
        ɵɵproperty("allowEditing", false)("formItem", ɵɵpureFunction0(54, _c3$3));
        ɵɵadvance(1);
        ɵɵproperty("allowEditing", false)("formItem", ɵɵpureFunction0(55, _c3$3));
        ɵɵadvance(1);
        ɵɵproperty("visible", false)("showInColumnChooser", false);
        ɵɵadvance(1);
        ɵɵproperty("dataSource", ctx.tagTypes);
        ɵɵadvance(2);
        ɵɵproperty("visible", false)("showInColumnChooser", false);
        ɵɵadvance(1);
        ɵɵproperty("dataSource", ctx.tagCategories);
        ɵɵadvance(2);
        ɵɵproperty("showInColumnChooser", false)("allowFiltering", false)("allowSearch", false)("visible", false);
        ɵɵadvance(1);
        ɵɵproperty("dxTemplateOf", "attributesSelector");
        ɵɵadvance(1);
        ɵɵproperty("allowHiding", false)("width", 110);
        ɵɵadvance(1);
        ɵɵproperty("onClick", ctx.detachTag);
        ɵɵadvance(1);
        ɵɵproperty("onClick", ctx.showAttributes);
        ɵɵadvance(1);
        ɵɵproperty("onClick", ctx.cloneTag);
        ɵɵadvance(3);
        ɵɵproperty("allowDeleting", ctx.canDelete)("allowAdding", ctx.canAdd)("allowUpdating", ctx.canEdit);
        ɵɵadvance(1);
        ɵɵproperty("toolbarItems", ctx.editToolbarItems);
        ɵɵadvance(7);
        ɵɵproperty("label", ɵɵpureFunction0(56, _c3$3));
        ɵɵadvance(1);
        ɵɵproperty("enabled", true);
        ɵɵadvance(1);
        ɵɵproperty("visible", false);
        ɵɵadvance(1);
        ɵɵproperty("enabled", true)("allowExportSelectedData", true);
        ɵɵadvance(2);
        ɵɵproperty("pageSize", 25);
        ɵɵadvance(1);
        ɵɵproperty("showPageSizeSelector", true)("allowedPageSizes", ɵɵpureFunction0(57, _c4$2))("showInfo", true);
        ɵɵadvance(1);
        ɵɵproperty("visible", true);
        ɵɵadvance(1);
        ɵɵproperty("visible", true)("width", 240);
        ɵɵadvance(1);
        ɵɵproperty("visible", true);
        ɵɵadvance(1);
        ɵɵproperty("dxTemplateOf", "details");
        ɵɵadvance(1);
        ɵɵproperty("dxTemplateOf", "tagsSelectorTemplate");
    } }, directives: [DxDataGridComponent, GridDefaultDirective, DxiColumnComponent, DxiValidationRuleComponent, DxoLookupComponent, DxTemplateDirective, DxiButtonComponent, DxoEditingComponent, DxoPopupComponent, DxoFormComponent, DxiItemComponent, DxoColumnChooserComponent, DxoGroupPanelComponent, DxoExportComponent, DxoSortingComponent, DxoPagingComponent, DxoPagerComponent, DxoFilterRowComponent, DxoSearchPanelComponent, DxoHeaderFilterComponent, TagAttributesEditorComponent, DxButtonComponent, DxSelectBoxComponent, NgForOf], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TagsViewerComponent, [{
        type: Component,
        args: [{
                selector: 'lib-tags-viewer',
                templateUrl: './tags-viewer.component.html',
                styleUrls: ['./tags-viewer.component.scss']
            }]
    }], function () { return [{ type: TagsViewerService }, { type: User }]; }, { taggable: [{
            type: Input
        }], grid: [{
            type: ViewChild,
            args: [DxDataGridComponent]
        }] }); })();

class GridDefaultModule {
}
GridDefaultModule.ɵmod = ɵɵdefineNgModule({ type: GridDefaultModule });
GridDefaultModule.ɵinj = ɵɵdefineInjector({ factory: function GridDefaultModule_Factory(t) { return new (t || GridDefaultModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(GridDefaultModule, { declarations: [GridDefaultDirective], imports: [CommonModule], exports: [GridDefaultDirective] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(GridDefaultModule, [{
        type: NgModule,
        args: [{
                declarations: [GridDefaultDirective],
                imports: [
                    CommonModule
                ],
                exports: [GridDefaultDirective]
            }]
    }], null, null); })();

class GridTitleDirective {
    constructor(grid) {
        this.grid = grid;
    }
    ngOnInit() {
        this.sub = this.grid.onToolbarPreparing.subscribe((e) => {
            e.toolbarOptions.items.unshift({
                location: 'before',
                template: this.titleEl(),
            });
        });
    }
    titleEl() {
        const el = document.createElement('h1');
        el.classList.add('flex', 'flex-wrap', 'items-center', 'grid-title');
        let html = '';
        if (this.libGridTitle.icon) {
            html += `<svg  width="24px" height="24px" viewBox="0 0 24 24">${this.libGridTitle.icon.body}</svg>`;
        }
        html += this.libGridTitle.text || '';
        el.innerHTML = html;
        return el;
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
GridTitleDirective.ɵfac = function GridTitleDirective_Factory(t) { return new (t || GridTitleDirective)(ɵɵdirectiveInject(DxDataGridComponent)); };
GridTitleDirective.ɵdir = ɵɵdefineDirective({ type: GridTitleDirective, selectors: [["", "libGridTitle", ""]], inputs: { libGridTitle: "libGridTitle" } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(GridTitleDirective, [{
        type: Directive,
        args: [{
                selector: '[libGridTitle]'
            }]
    }], function () { return [{ type: DxDataGridComponent }]; }, { libGridTitle: [{
            type: Input
        }] }); })();

class GridTitleModule {
}
GridTitleModule.ɵmod = ɵɵdefineNgModule({ type: GridTitleModule });
GridTitleModule.ɵinj = ɵɵdefineInjector({ factory: function GridTitleModule_Factory(t) { return new (t || GridTitleModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(GridTitleModule, { declarations: [GridTitleDirective], imports: [CommonModule], exports: [GridTitleDirective] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(GridTitleModule, [{
        type: NgModule,
        args: [{
                declarations: [GridTitleDirective],
                imports: [
                    CommonModule
                ],
                exports: [GridTitleDirective]
            }]
    }], null, null); })();

class TagsViewerModule {
}
TagsViewerModule.ɵmod = ɵɵdefineNgModule({ type: TagsViewerModule });
TagsViewerModule.ɵinj = ɵɵdefineInjector({ factory: function TagsViewerModule_Factory(t) { return new (t || TagsViewerModule)(); }, imports: [[
            CommonModule,
            DxDataGridModule,
            GridDefaultModule,
            GridTitleModule,
            TagAttributesEditorModule,
            DxButtonModule,
            DxSelectBoxModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(TagsViewerModule, { declarations: [TagsViewerComponent], imports: [CommonModule,
        DxDataGridModule,
        GridDefaultModule,
        GridTitleModule,
        TagAttributesEditorModule,
        DxButtonModule,
        DxSelectBoxModule], exports: [TagsViewerComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(TagsViewerModule, [{
        type: NgModule,
        args: [{
                declarations: [TagsViewerComponent],
                imports: [
                    CommonModule,
                    DxDataGridModule,
                    GridDefaultModule,
                    GridTitleModule,
                    TagAttributesEditorModule,
                    DxButtonModule,
                    DxSelectBoxModule
                ],
                exports: [TagsViewerComponent]
            }]
    }], null, null); })();

class TreeListTitleDirective {
    constructor(tree) {
        this.tree = tree;
    }
    ngOnInit() {
        this.tree.onToolbarPreparing.pipe(first()).subscribe((e) => {
            e.toolbarOptions.items.unshift({
                location: 'before',
                template: this.titleEl(),
            });
        });
    }
    titleEl() {
        const h = document.createElement('h1');
        h.classList.add('flex', 'flex-wrap', 'items-center', 'grid-title');
        let html = '';
        if (this.libTreeListTitle.icon) {
            html += `<svg  width="24px" height="24px" viewBox="0 0 24 24">${this.libTreeListTitle.icon.body}</svg>`;
        }
        html += this.libTreeListTitle.text;
        h.innerHTML = html;
        return h;
    }
}
TreeListTitleDirective.ɵfac = function TreeListTitleDirective_Factory(t) { return new (t || TreeListTitleDirective)(ɵɵdirectiveInject(DxTreeListComponent)); };
TreeListTitleDirective.ɵdir = ɵɵdefineDirective({ type: TreeListTitleDirective, selectors: [["", "libTreeListTitle", ""]], inputs: { libTreeListTitle: "libTreeListTitle" } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TreeListTitleDirective, [{
        type: Directive,
        args: [{
                selector: '[libTreeListTitle]'
            }]
    }], function () { return [{ type: DxTreeListComponent }]; }, { libTreeListTitle: [{
            type: Input
        }] }); })();

class TreeListTitleModule {
}
TreeListTitleModule.ɵmod = ɵɵdefineNgModule({ type: TreeListTitleModule });
TreeListTitleModule.ɵinj = ɵɵdefineInjector({ factory: function TreeListTitleModule_Factory(t) { return new (t || TreeListTitleModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(TreeListTitleModule, { declarations: [TreeListTitleDirective], imports: [CommonModule], exports: [TreeListTitleDirective] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(TreeListTitleModule, [{
        type: NgModule,
        args: [{
                declarations: [TreeListTitleDirective],
                imports: [
                    CommonModule
                ],
                exports: [TreeListTitleDirective]
            }]
    }], null, null); })();

class TreeListDefaultDirective {
    constructor(tree) {
        this.tree = tree;
        this.tree.allowColumnReordering = true;
        this.tree.allowColumnResizing = true;
        this.tree.columnHidingEnabled = true;
        this.tree.errorRowEnabled = false;
        this.tree.showBorders = false;
        this.tree.showRowLines = true;
        this.tree.remoteOperations = { sorting: false, filtering: false };
        this.tree.rowAlternationEnabled = true;
        this.tree.columnAutoWidth = true;
        this.stateStoring();
    }
    ngOnInit() {
        this.tree.onToolbarPreparing.pipe(first()).subscribe((e) => {
            e.toolbarOptions.items.splice(e.toolbarOptions.items.length - 2, 0, {
                location: 'after',
                widget: 'dxButton',
                options: {
                    hint: 'Réinitialiser les paramètres du tableau',
                    icon: 'clearformat',
                    onClick: () => {
                        localStorage.removeItem(this.options.stateStorageKey);
                        this.tree.instance.state(null);
                    }
                },
            }, {
                location: 'after',
                widget: 'dxButton',
                options: {
                    hint: 'Actualiser',
                    icon: 'refresh',
                    onClick: () => {
                        this.tree.instance.refresh();
                    }
                },
            });
        });
    }
    stateStoring() {
        this.tree.stateStoring = {
            enabled: true,
            type: 'custom',
            customLoad: () => {
                return JSON.parse(localStorage.getItem(this.options.stateStorageKey));
            },
            customSave: (state) => {
                localStorage.setItem(this.options.stateStorageKey, JSON.stringify({
                    columns: state.columns,
                    allowedPageSizes: state.allowedPageSizes,
                    pageSize: state.pageSize,
                }));
            },
        };
    }
}
TreeListDefaultDirective.ɵfac = function TreeListDefaultDirective_Factory(t) { return new (t || TreeListDefaultDirective)(ɵɵdirectiveInject(DxTreeListComponent)); };
TreeListDefaultDirective.ɵdir = ɵɵdefineDirective({ type: TreeListDefaultDirective, selectors: [["", "libTreeListDefault", ""]], inputs: { options: ["libTreeListDefault", "options"] } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TreeListDefaultDirective, [{
        type: Directive,
        args: [{
                selector: '[libTreeListDefault]'
            }]
    }], function () { return [{ type: DxTreeListComponent }]; }, { options: [{
            type: Input,
            args: ['libTreeListDefault']
        }] }); })();

class TreeListDefaultModule {
}
TreeListDefaultModule.ɵmod = ɵɵdefineNgModule({ type: TreeListDefaultModule });
TreeListDefaultModule.ɵinj = ɵɵdefineInjector({ factory: function TreeListDefaultModule_Factory(t) { return new (t || TreeListDefaultModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(TreeListDefaultModule, { declarations: [TreeListDefaultDirective], imports: [CommonModule], exports: [TreeListDefaultDirective] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(TreeListDefaultModule, [{
        type: NgModule,
        args: [{
                declarations: [TreeListDefaultDirective],
                imports: [
                    CommonModule
                ],
                exports: [TreeListDefaultDirective]
            }]
    }], null, null); })();

function DomainsSelectorComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "span", 8);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const group_r1 = ctx.$implicit;
    ɵɵadvance(2);
    ɵɵtextInterpolate(group_r1.value);
} }
const _c0$7 = function () { return { autoExpandAll: true, allowCollapsing: false }; };
const _c1$6 = function () { return { mode: "infinite" }; };
class DomainsSelectorComponent {
    constructor() {
        this.valueChange = new EventEmitter();
    }
    ngOnInit() {
        this.value = this.value || [];
        // Data source
        this.ds = new DataSource({
            paginate: false,
            store: new ArrayStore({
                key: 'id',
                data: this.domains,
            }),
        });
    }
    onSelectionChanged(e) {
        this.valueChange.emit(e.selectedRowsData);
    }
    ngAfterViewInit() {
        this.grid.instance.selectRows(this.value.map(d => d.id), false);
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('value') && this.grid) {
            this.grid.instance.selectRows(this.value.map(d => d.id), false);
        }
    }
}
DomainsSelectorComponent.ɵfac = function DomainsSelectorComponent_Factory(t) { return new (t || DomainsSelectorComponent)(); };
DomainsSelectorComponent.ɵcmp = ɵɵdefineComponent({ type: DomainsSelectorComponent, selectors: [["lib-domains-selector"]], viewQuery: function DomainsSelectorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(DxDataGridComponent, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.grid = _t.first);
    } }, inputs: { domains: "domains", value: "value" }, outputs: { valueChange: "valueChange" }, features: [ɵɵNgOnChangesFeature], decls: 9, vars: 12, consts: [[3, "dataSource", "grouping", "hoverStateEnabled", "scrolling", "height", "onSelectionChanged"], ["caption", "Nom", "width", "25%", "dataField", "name"], ["dataType", "string", "alignment", "left", "dataField", "business_unit_name", "groupCellTemplate", "groupTemplate"], [4, "dxTemplate", "dxTemplateOf"], ["caption", "ID", "dataField", "id", "sortOrder", "asc", "width", "10%", "dataType", "number"], ["selectAllMode", "page", "showCheckBoxesMode", "always", "mode", "multiple"], [3, "visible"], [3, "visible", "width"], [1, "block", "font-normal", "uppercase", "group-name"]], template: function DomainsSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "dx-data-grid", 0);
        ɵɵlistener("onSelectionChanged", function DomainsSelectorComponent_Template_dx_data_grid_onSelectionChanged_0_listener($event) { return ctx.onSelectionChanged($event); });
        ɵɵelement(1, "dxi-column", 1);
        ɵɵelement(2, "dxi-column", 2);
        ɵɵtemplate(3, DomainsSelectorComponent_div_3_Template, 3, 1, "div", 3);
        ɵɵelement(4, "dxi-column", 4);
        ɵɵelement(5, "dxo-selection", 5);
        ɵɵelement(6, "dxo-header-filter", 6);
        ɵɵelement(7, "dxo-filter-row", 6);
        ɵɵelement(8, "dxo-search-panel", 7);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("dataSource", ctx.ds)("grouping", ɵɵpureFunction0(10, _c0$7))("hoverStateEnabled", true)("scrolling", ɵɵpureFunction0(11, _c1$6))("height", 450);
        ɵɵadvance(3);
        ɵɵproperty("dxTemplateOf", "groupTemplate");
        ɵɵadvance(3);
        ɵɵproperty("visible", true);
        ɵɵadvance(1);
        ɵɵproperty("visible", true);
        ɵɵadvance(1);
        ɵɵproperty("visible", true)("width", 240);
    } }, directives: [DxDataGridComponent, DxiColumnComponent, DxTemplateDirective, DxoSelectionComponent, DxoHeaderFilterComponent, DxoFilterRowComponent, DxoSearchPanelComponent], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DomainsSelectorComponent, [{
        type: Component,
        args: [{
                selector: 'lib-domains-selector',
                templateUrl: './domains-selector.component.html',
                styleUrls: ['./domains-selector.component.scss']
            }]
    }], function () { return []; }, { grid: [{
            type: ViewChild,
            args: [DxDataGridComponent, { static: false }]
        }], domains: [{
            type: Input
        }], value: [{
            type: Input
        }], valueChange: [{
            type: Output
        }] }); })();

class DomainsSelectorModule {
}
DomainsSelectorModule.ɵmod = ɵɵdefineNgModule({ type: DomainsSelectorModule });
DomainsSelectorModule.ɵinj = ɵɵdefineInjector({ factory: function DomainsSelectorModule_Factory(t) { return new (t || DomainsSelectorModule)(); }, imports: [[
            CommonModule,
            DxDataGridModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(DomainsSelectorModule, { declarations: [DomainsSelectorComponent], imports: [CommonModule,
        DxDataGridModule], exports: [DomainsSelectorComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(DomainsSelectorModule, [{
        type: NgModule,
        args: [{
                declarations: [DomainsSelectorComponent],
                imports: [
                    CommonModule,
                    DxDataGridModule
                ],
                exports: [DomainsSelectorComponent]
            }]
    }], null, null); })();

function DomainsSelectorDropdownComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "lib-domains-selector", 3);
    ɵɵlistener("valueChange", function DomainsSelectorDropdownComponent_div_2_Template_lib_domains_selector_valueChange_1_listener($event) { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(); return ctx_r2.changed($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("domains", ctx_r0.domains)("value", ctx_r0.value);
} }
class DomainsSelectorDropdownComponent {
    constructor() {
        this.valueChange = new EventEmitter();
    }
    ngOnInit() {
        // this.selected = this.value;
        // Data source
        this.ds = new DataSource({
            paginate: false,
            store: new ArrayStore({
                key: 'id',
                data: this.domains,
            }),
        });
    }
    onShowing(e) {
        e.component.content().classList.add('domain-selector-dropdown');
    }
    changed(e) {
        this.selected = e;
        this.valueChange.emit(e);
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('value')) {
            this.selected = changes.value.currentValue;
        }
    }
}
DomainsSelectorDropdownComponent.ɵfac = function DomainsSelectorDropdownComponent_Factory(t) { return new (t || DomainsSelectorDropdownComponent)(); };
DomainsSelectorDropdownComponent.ɵcmp = ɵɵdefineComponent({ type: DomainsSelectorDropdownComponent, selectors: [["lib-domains-selector-dropdown"]], inputs: { domains: "domains", value: "value", dropdownWidth: "dropdownWidth", title: "title" }, outputs: { valueChange: "valueChange" }, features: [ɵɵNgOnChangesFeature], decls: 3, vars: 5, consts: [["displayExpr", "name", "placeholder", "S\u00E9lectionnez des domaines", 3, "value", "dataSource"], [3, "width", "onShowing"], [4, "dxTemplate", "dxTemplateOf"], [3, "domains", "value", "valueChange"]], template: function DomainsSelectorDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "dx-drop-down-box", 0);
        ɵɵelement(1, "dxo-drop-down-options", 1);
        ɵɵtemplate(2, DomainsSelectorDropdownComponent_div_2_Template, 2, 2, "div", 2);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("value", ctx.selected)("dataSource", ctx.ds);
        ɵɵadvance(1);
        ɵɵproperty("width", ctx.dropdownWidth)("onShowing", ctx.onShowing);
        ɵɵadvance(1);
        ɵɵproperty("dxTemplateOf", "content");
    } }, directives: [DxDropDownBoxComponent, DxoDropDownOptionsComponent, DxTemplateDirective, DomainsSelectorComponent], styles: [".domain-selector-dropdown{overflow:hidden;padding:0}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DomainsSelectorDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'lib-domains-selector-dropdown',
                templateUrl: './domains-selector-dropdown.component.html',
                styleUrls: ['./domains-selector-dropdown.component.scss']
            }]
    }], function () { return []; }, { domains: [{
            type: Input
        }], value: [{
            type: Input
        }], dropdownWidth: [{
            type: Input
        }], title: [{
            type: Input
        }], valueChange: [{
            type: Output
        }] }); })();

class DomainsSelectorDropdownModule {
}
DomainsSelectorDropdownModule.ɵmod = ɵɵdefineNgModule({ type: DomainsSelectorDropdownModule });
DomainsSelectorDropdownModule.ɵinj = ɵɵdefineInjector({ factory: function DomainsSelectorDropdownModule_Factory(t) { return new (t || DomainsSelectorDropdownModule)(); }, imports: [[
            CommonModule,
            DxDropDownBoxModule,
            DomainsSelectorModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(DomainsSelectorDropdownModule, { declarations: [DomainsSelectorDropdownComponent], imports: [CommonModule,
        DxDropDownBoxModule,
        DomainsSelectorModule], exports: [DomainsSelectorDropdownComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(DomainsSelectorDropdownModule, [{
        type: NgModule,
        args: [{
                declarations: [DomainsSelectorDropdownComponent],
                imports: [
                    CommonModule,
                    DxDropDownBoxModule,
                    DomainsSelectorModule
                ],
                exports: [DomainsSelectorDropdownComponent]
            }]
    }], null, null); })();

const _c0$8 = function () { return { stylingMode: "underlined" }; };
function RoleSelectorDropdownComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "dx-tree-view", 3);
    ɵɵlistener("onContentReady", function RoleSelectorDropdownComponent_div_2_Template_dx_tree_view_onContentReady_1_listener($event) { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(); return $event.component.selectItem(ctx_r2.selected); })("onItemSelectionChanged", function RoleSelectorDropdownComponent_div_2_Template_dx_tree_view_onItemSelectionChanged_1_listener($event) { ɵɵrestoreView(_r3); const ctx_r4 = ɵɵnextContext(); return ctx_r4.onItemSelectionChanged($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("dataSource", ctx_r0.roles)("searchEnabled", true)("expandAllEnabled", true)("searchEditorOptions", ɵɵpureFunction0(5, _c0$8))("selectByClick", false);
} }
class RoleSelectorDropdownComponent {
    constructor() {
        this.valueChange = new EventEmitter();
    }
    ngOnInit() {
        this.selected = this.value;
        // Array Store
        this.store = new ArrayStore({
            key: 'id',
            data: this.roles,
        });
        // Data source
        this.ds = new DataSource({
            paginate: false,
            store: this.store,
        });
    }
    onShowing(e) {
        // e.component.content().classList.add('role-selector-dropdown');
    }
    onItemSelectionChanged(e) {
        this.selected = e.itemData.id;
        this.valueChange.emit(e.itemData.id);
    }
}
RoleSelectorDropdownComponent.ɵfac = function RoleSelectorDropdownComponent_Factory(t) { return new (t || RoleSelectorDropdownComponent)(); };
RoleSelectorDropdownComponent.ɵcmp = ɵɵdefineComponent({ type: RoleSelectorDropdownComponent, selectors: [["lib-role-selector-dropdown"]], inputs: { roles: "roles", value: "value" }, outputs: { valueChange: "valueChange" }, decls: 3, vars: 5, consts: [["displayExpr", "name", "valueExpr", "id", "placeholder", "S\u00E9lectionnez un role", 3, "value", "dataSource"], [3, "width", "onShowing"], [4, "dxTemplate", "dxTemplateOf"], ["searchMode", "contains", "dataStructure", "plain", "keyExpr", "id", "parentIdExpr", "parent_id", "selectionMode", "single", "displayExpr", "name", "showCheckBoxesMode", "normal", 3, "dataSource", "searchEnabled", "expandAllEnabled", "searchEditorOptions", "selectByClick", "onContentReady", "onItemSelectionChanged"]], template: function RoleSelectorDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "dx-drop-down-box", 0);
        ɵɵelement(1, "dxo-drop-down-options", 1);
        ɵɵtemplate(2, RoleSelectorDropdownComponent_div_2_Template, 2, 6, "div", 2);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("value", ctx.selected)("dataSource", ctx.roles);
        ɵɵadvance(1);
        ɵɵproperty("width", 450)("onShowing", ctx.onShowing);
        ɵɵadvance(1);
        ɵɵproperty("dxTemplateOf", "content");
    } }, directives: [DxDropDownBoxComponent, DxoDropDownOptionsComponent, DxTemplateDirective, DxTreeViewComponent], styles: [".role-selector-dropdown{overflow:hidden;padding:0}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RoleSelectorDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'lib-role-selector-dropdown',
                templateUrl: './role-selector-dropdown.component.html',
                styleUrls: ['./role-selector-dropdown.component.scss']
            }]
    }], function () { return []; }, { roles: [{
            type: Input
        }], value: [{
            type: Input
        }], valueChange: [{
            type: Output
        }] }); })();

class RoleSelectorDropdownModule {
}
RoleSelectorDropdownModule.ɵmod = ɵɵdefineNgModule({ type: RoleSelectorDropdownModule });
RoleSelectorDropdownModule.ɵinj = ɵɵdefineInjector({ factory: function RoleSelectorDropdownModule_Factory(t) { return new (t || RoleSelectorDropdownModule)(); }, imports: [[
            CommonModule,
            DxDropDownBoxModule,
            DxTreeViewModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(RoleSelectorDropdownModule, { declarations: [RoleSelectorDropdownComponent], imports: [CommonModule,
        DxDropDownBoxModule,
        DxTreeViewModule], exports: [RoleSelectorDropdownComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(RoleSelectorDropdownModule, [{
        type: NgModule,
        args: [{
                declarations: [RoleSelectorDropdownComponent],
                imports: [
                    CommonModule,
                    DxDropDownBoxModule,
                    DxTreeViewModule
                ],
                exports: [RoleSelectorDropdownComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of shared
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AuthGuard, AuthModule, AuthService, BadgeComponent, BadgeModule, BusinessUnit, CONFIG_MODULE_OPTIONS_TOKEN, ConfigModule, ConfigService, Crop, CropCategory, Domain, DomainsSelectorComponent, DomainsSelectorDropdownComponent, DomainsSelectorDropdownModule, DomainsSelectorModule, Driver, ErrorsService, Field, FieldCrop, FieldCropNote, FieldDrawComponent, FieldDrawModule, FieldIntervention, FieldSvgComponent, FieldSvgModule, FieldsRBush, FlowMeterBatchDataLoader, FlowMeterData, FlowMeterDataLoader, FlowMeterEntry, FuelConsumption, FuelLevel, FuelParamsEditorComponent, FuelParamsEditorModule, GlobalErrorHandler, GridDefaultDirective, GridDefaultModule, GridTitleDirective, GridTitleModule, GroupedModelsList, LevelCalibrationComponent, LevelCalibrationModule, Message, ModelsList, Notification, Packet, PasswordChangeRequest, Permission, Poi, PoiCategory, ProfileEditFormComponent, ProfileEditFormModule, ProfilePhotoUploadComponent, ProfilePhotoUploadModule, ProfileResolver, ProfileService, PulseDotComponent, PulseDotModule, Role, RoleSelectorDropdownComponent, RoleSelectorDropdownModule, Route, RouteDriveTag, RouteEndTag, RouteLoader, RoutePacketTag, RouteParams, RouteRenderer, RouteStartTag, RouteStopTag, RouteTagRow, RouteTimeline, Sensor, SensorHistoryLoader, SensorRecord, SensorSettings, SensorValueChange, Setting, SharedComponent, SharedModule, SharedService, StoreService, TRAILER_INTERVENTION_OVER_SPEED_NOTIFICATION, TRAILER_INTERVENTION_UNDER_SPEED_NOTIFICATION, Tag, TagAttribute, TagAttributesEditorComponent, TagAttributesEditorModule, TagDetails, TagsViewerComponent, TagsViewerModule, Tank, ThirdpartySystem, ThirdpartySystemResourceTypeFields, Ticket, TicketsComment, TicketsComments, Tracker, TrackerAssignment, TrackerChooserComponent, TrackerChooserModule, TrackerSettings, TrackerState, Tractor, Trailer, TrailerIntervention, TrailerInterventionAlert, TrailerInterventionMetrics, TrailerInterventionStatus, TrailerOperationType, TrailerOperationTypeRules, TrailerOperationTypeSettings, TransportIntervention, TransportInterventionDashboardMetrics, TransportInterventionEndpoints, TransportInterventionMetrics, TransportInterventionPoi, TransportInterventionPoiGroupReport, TransportInterventionRealtime, TransportInterventionsStatus, TreeListDefaultDirective, TreeListDefaultModule, TreeListTitleDirective, TreeListTitleModule, User, UserDomain, UserDomainDetails, Vehicle, VehicleSettings, VehicleTrackerStateIcon, calcLuminance, configServiceProvider, dateFilterToPeriod, dateFilters, durationToHoursStr, durationToStr, durationToStrOld, formatBytes, getMapSatelliteLayer, getMapStreetLayer, kmlParser, mapLayersControl, mapSatelliteLayer, mapStreetLayer, massKmlParser, notify, positionToURL, romanize, tagCategories, tagTypes, taggableTypeTagCategories, transportInterventionPoiDiffAndGroupReport, transportInterventionPoiListReport };
//# sourceMappingURL=shared.js.map
